{
  "account.account": "Profil og sikkerhet",
  "account.accountDeleted": "Kontoen din er slettet.",
  "account.accountDescription": "Navn, passord, sletting av konto",
  "account.accountSection": "Konto",
  "account.changeEmail": "Endre e-post",
  "account.changePassword": "Bytt passord",
  "account.currentPassword": "Nåværende passord",
  "account.dangerZone": "Faresone",
  "account.deleteAccount": "Slett kontoen din",
  "account.deleteAccountConfirmation": "Er du sikker på at du vil slette kontoen din? Du kan ikke angre hvis du sletter konto!",
  "account.deleteAccountDescription": "Denne handlingen sletter kontoen din og all informasjonen din. Det er ingen vei tilbake.",
  "account.emailChange": "Endre e-postadresse",
  "account.emailChangeConfirmation": "Bekreftelse av e-postendring",
  "account.emailChangeFailure": "Lenken for e-postendring er ugyldig eller har utløpt.",
  "account.emailChangeIntro": "Skriv inn den nye e-postadressen din og det nåværende passordet ditt. Vi sender en lenke til den nye adressen: e-postadressen endres først når du åpner den.",
  "account.emailChangeSuccess": "E-postadressen din er endret til {newEmail}.",
  "account.emailChangeSuccessNoAddress": "E-postadressen din er endret.",
  "account.emailChangeVerificationSent": "En bekreftelses-e-post er sendt til din nye e-postadresse. Sjekk innboksen din og klikk på lenken for å bekrefte endringen.",
  "account.manageAccount": "Administrer konto",
  "account.newEmailAddress": "Ny e-postadresse",
  "account.newPassword": "Nytt passord",
  "account.newPasswordAgain": "Gjenta nytt passord",
  "account.oldPassword": "Gammelt passord",
  "account.passwordChange": "Endring av passord",
  "account.passwordChangeDescription": "Hold kontoen din sikker",
  "account.passwordUpdated": "Passordet er oppdatert.",
  "account.profile": "Profil",
  "account.profileUpdated": "Profilen er oppdatert.",
  "account.signedInAs": "Logget inn som",
  "account.updateYourProfile": "Oppdater profilen din",
  "account.updateYourProfileDescription": "Navn og visningsinnstillinger",
  "addons.accountOnHold": "Kontotilkoblingen din har utløpt. Koble til på nytt for å gjenoppta dataoppdateringer.",
  "addons.accountOnHoldTitle": "Konto satt på pause",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Opprett og hent API-nøkkel fra denne lenken",
  "addons.ambientWeatherDescription": "Ambient Weather-værstasjoner (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API-nøkkel",
  "addons.applicationKey": "Programnøkkel",
  "addons.availableServices": "Tilgjengelig",
  "addons.cannotDisconnectLastAccount": "Kan ikke koble fra din eneste påloggingsmetode. Legg til en annen påloggingsmetode først.",
  "addons.connect": "Koble til",
  "addons.connected": "Tilkoblet",
  "addons.connectedAccounts": "Tilknyttede kontoer",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedServices": "Tilkoblet",
  "addons.connectedSince": "Tilkoblet siden {date}",
  "addons.connectionSection": "Tilkobling",
  "addons.connectionSuccess": "{provider}-konto tilkoblet",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "V2 API-nøkkel",
  "addons.davisDescription": "Davis-værstasjoner (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Hent V2 API nøkkel fra denne lenken",
  "addons.disconnect": "Koble fra",
  "addons.disconnectConfirmation": "Er du sikker på at du vil koble fra {provider}-kontoen din?",
  "addons.disconnectionSuccess": "{provider}-konto frakoblet",
  "addons.disconnectProviderDescription": "Stopper synkroniseringen. Historikken din beholdes.",
  "addons.ecowittCreateAndRetrieveKeys": "Opprett og hent både en API-nøkkel og programnøkkel fra denne lenken",
  "addons.ecowittDescription": "Ecowitt tilbyr profesjonell wifi værstasjon, trådløs inne- og utendørs termometre, fuktighetsmåler, høypresisjonsregnmåler, luftkvalitetsmåler osv.",
  "addons.helpLink": "Slik kobler du til {provider}",
  "addons.integrationsSection": "Integrasjoner",
  "addons.myAcuriteAccountOnHold": "Kontoen din er satt på vent. Vennligst skriv inn passordet ditt for å koble til kontoen din på nytt",
  "addons.myAcuriteDescription": "AcuRite er det #1 værstasjonsmerket i Nord-Amerika. Som ledende innen tid, temperatur og værteknologi gir AcuRite deg detaljert informasjon om innendørs- og utendørsmiljøet ditt slik at du kan planlegge dagen med selvtillit.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Bruk Netatmo termostaten til å endre temperaturen i hjemmet ditt fra sengen - eller fra den andre siden av kloden.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Din personlige værstasjon",
  "addons.notConnected": "Ikke tilkoblet",
  "addons.or": "eller",
  "addons.providerAccountDisconnected": "Tilkoblingen til værtjenesten din har utløpt. Koble til på nytt for å gjenoppta dataoppdateringer.",
  "addons.reconnect": "Koble til igjen",
  "addons.socialConnectionsIntro": "Koble til dine sosiale kontoer for rask pålogging. Du kan koble til eller fra kontoer når som helst.",
  "addons.weatherflowCreateToken": "Lag og hent ditt token fra denne lenken",
  "addons.weatherflowTempestDescription": "Tempest værsystem med innebygd vind- og regnmåler",
  "addons.weatherServices": "Værtjenester",
  "addons.weatherServicesConnected": "{count, plural, =0 {Ingen tjenester tilkoblet} one {# tjeneste tilkoblet} other {# tjenester tilkoblet}}",
  "addons.weatherServicesDescription": "Koble til Netatmo, Davis, Weatherflow og mer",
  "addons.wundergroundApiKey": "API-nøkkel",
  "addons.wundergroundDescription": "Weather Underground er et globalt fellesskap av mennesker som kobler data fra miljøsensorer som værstasjoner og luftkvalitetsmonitorer, slik at vi kan gi de rikholdige, hyperlokale dataene du trenger for å drive med hobbyene dine",
  "addons.wundergroundRetrieveApiKey": "Hent API-nøkkelen din med denne lenken",
  "addons.wundergroundStationId": "Stasjons-ID",
  "airQuality.adviceActivityGood": "En ideell dag for aktivitet utendørs",
  "airQuality.adviceActivityHazardous": "Unngå all fysisk aktivitet utendørs",
  "airQuality.adviceActivityLabel": "Fysisk aktivitet",
  "airQuality.adviceActivityModerate": "En god dag for aktivitet utendørs",
  "airQuality.adviceActivitySensitive": "Vurder kortere og mindre intense aktiviteter utendørs",
  "airQuality.adviceActivityUnhealthy": "Reduser lange eller intense aktiviteter og ta flere pauser",
  "airQuality.adviceActivityVeryUnhealthy": "Unngå lange eller intense aktiviteter; vurder å flytte dem innendørs",
  "airQuality.adviceGroupsGood": "Ingen spesielle forholdsregler nødvendig",
  "airQuality.adviceGroupsHazardous": "Hold deg innendørs og hold aktivitetsnivået lavt",
  "airQuality.adviceGroupsLabel": "Følsomme grupper",
  "airQuality.adviceGroupsModerate": "Særlig følsomme personer: kortere og mindre intense aktiviteter",
  "airQuality.adviceGroupsSensitive": "Gjør aktiviteter utendørs kortere og mindre intense og ta flere pauser",
  "airQuality.adviceGroupsUnhealthy": "Unngå lange eller intense aktiviteter utendørs; vurder å flytte dem innendørs",
  "airQuality.adviceGroupsVeryUnhealthy": "Unngå all fysisk aktivitet utendørs; utsett den eller flytt den innendørs",
  "airQuality.adviceTimingLabel": "Når du bør gå ut",
  "airQuality.adviceTimingMorning": "Helst om formiddagen – da er ozonnivået lavere",
  "airQuality.airQuality": "Luftkvalitet",
  "airQuality.airQualityIndex": "Luftkvalitetsindeks",
  "airQuality.aqiForecast": "Varsel for luftkvalitet",
  "airQuality.co2Fresh": "Frisk",
  "airQuality.co2GettingStale": "Litt tungt",
  "airQuality.co2Stale": "Tungt",
  "airQuality.dailyForecast": "Dagsvarsel",
  "airQuality.dominantPollutant": "Dominerende forurensning",
  "airQuality.expectedPeak": "Forventet topp",
  "airQuality.good": "God",
  "airQuality.goodDescription": "Luftkvaliteten anses som tilfredsstillende og luftforurensning utgjør liten eller ingen risiko",
  "airQuality.hazardous": "Farlig",
  "airQuality.hazardousDescription": "Helsevarsel: Alle kan oppleve mer alvorlige helseeffekter",
  "airQuality.indoorAirQuality": "Innendørs luftkvalitet",
  "airQuality.moderate": "Moderat",
  "airQuality.moderateDescription": "Luftkvaliteten er akseptabel. For noen typer forurensninger kan det imidlertid være et moderat helseproblem for et svært lite antall mennesker som er uvanlig følsomme for luftforurensning.",
  "airQuality.noForecastForLocation": "Det finnes ingen luftkvalitetsvarsel for dette stedet.",
  "airQuality.now": "Nå",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Forurensende stoffer",
  "airQuality.recommendations": "Anbefalinger",
  "airQuality.sensitiveUnhealthy": "Usunn for sensitive grupper",
  "airQuality.sensitiveUnhealthyDescription": "Medlemmer av sensitive grupper kan oppleve helseeffekter. Det er ikke sannsynlig at allmennheten blir påvirket.",
  "airQuality.subIndex": "AQI-delindeks",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Forstå indeksen",
  "airQuality.unhealthy": "Usunn",
  "airQuality.unhealthyDescription": "Alle kan begynne å oppleve helseeffekter. Medlemmer av sensitive grupper kan oppleve mer alvorlige helseeffekter",
  "airQuality.veryUnhealthy": "Veldig usunn",
  "airQuality.veryUnhealthyDescription": "Helsevarsler om nødstilfeller. Det er mer sannsynlig at hele befolkningen blir rammet.",
  "alerts.addAlert": "Legg til varsel",
  "alerts.addCondition": "Legg til betingelse",
  "alerts.alertAdded": "Varselet er lagt til",
  "alerts.alertAuthorizationNotice": "Varsler fungerer bare hvis du gir SmartMixin fullmakt til å vise varsler",
  "alerts.alertDeleted": "Varselet ble slettet",
  "alerts.alertName": "Varselnavn",
  "alerts.alertWhen": "Jeg vil bli varslet når:",
  "alerts.aqiGreaterThan": "AQI høyere enn",
  "alerts.aqiGreaterThanThreshold": "AQI høyere enn grense på {value}{unit}",
  "alerts.aqiLessThan": "AQI lavere enn",
  "alerts.aqiLessThanThreshold": "AQI lavere enn grense på {value}{unit}",
  "alerts.atLeastOneCondition": "Du må legge til minst én betingelse",
  "alerts.co2GreaterThan": "CO2 høyere enn",
  "alerts.co2GreaterThanThreshold": "CO2 høyere enn grense på {value}{unit}",
  "alerts.co2LessThan": "CO2 lavere enn",
  "alerts.co2LessThanThreshold": "CO2 lavere enn grense på {value}{unit}",
  "alerts.conditions": "Betingelser",
  "alerts.conditionsDroppedOnStationChange": "Støttes ikke av denne stasjonen og er fjernet: {conditions}",
  "alerts.createAlert": "Lag varsel",
  "alerts.dailyPrecipitationGreaterThan": "Daglig nedbør større enn",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Daglig nedbør over grensen på {value}{unit}",
  "alerts.deleteAlert": "Slett varsel",
  "alerts.editAlert": "Rediger varsel",
  "alerts.editCondition": "Rediger betingelse",
  "alerts.gustSpeedGreaterThan": "Vindkast høyere enn",
  "alerts.gustSpeedGreaterThanThreshold": "Vindkast høyere enn grense på {value}{unit}",
  "alerts.gustSpeedLessThan": "Vindkast lavere enn",
  "alerts.gustSpeedLessThanThreshold": "Vindkast lavere enn grense på {value}{unit}",
  "alerts.heatIndexGreaterThan": "Varmeindeks høyere enn",
  "alerts.heatIndexGreaterThanThreshold": "Varmeindeks høyere enn grense på {value}{unit}",
  "alerts.heatIndexLessThan": "Varmeindeks lavere enn",
  "alerts.heatIndexLessThanThreshold": "Varmeindeks lavere enn grense på {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex høyere enn",
  "alerts.humidexGreaterThanThreshold": "Humidex høyere enn grense på {value}{unit}",
  "alerts.humidexLessThan": "Humidex lavere enn",
  "alerts.humidexLessThanThreshold": "Humidex lavere enn grense på {value}{unit}",
  "alerts.humidityGreaterThan": "Luftfuktighet høyere enn",
  "alerts.humidityGreaterThanThreshold": "Luftfuktighet høyere enn grense på {value}{unit}",
  "alerts.humidityLessThan": "Luftfuktighet lavere enn",
  "alerts.humidityLessThanThreshold": "Luftfuktighet lavere enn grense på {value}{unit}",
  "alerts.inProgress": "Pågår",
  "alerts.leafWetnessGreaterThan": "Bladfuktighet høyere enn",
  "alerts.leafWetnessGreaterThanThreshold": "Bladfuktighet høyere enn grense på {value}{unit}",
  "alerts.leafWetnessLessThan": "Bladfuktighet lavere enn",
  "alerts.leafWetnessLessThanThreshold": "Bladfuktighet lavere enn grense på {value}{unit}",
  "alerts.myAlerts": "Mine varsler",
  "alerts.noConfiguredAlert": "Du har ikke konfigurert noen varsling ennå, begynn med å legge til en",
  "alerts.noiseGreaterThan": "Støy høyere enn",
  "alerts.noiseGreaterThanThreshold": "Støy høyere enn grense på {value}{unit}",
  "alerts.noiseLessThan": "Støy lavere enn",
  "alerts.noiseLessThanThreshold": "Støy lavere enn grense på {value}{unit}",
  "alerts.noteOnConditions": "Vær oppmerksom på at varselet utløses når alle betingelsene nedenfor er bekreftet",
  "alerts.noTriggerHistory": "Denne alarmen er ikke utløst ennå.",
  "alerts.pm10GreaterThan": "PM 10 høyere enn",
  "alerts.pm10GreaterThanThreshold": "PM 10 høyere enn grense på {value}{unit}",
  "alerts.pm10LessThan": "PM 10 lavere enn",
  "alerts.pm10LessThanThreshold": "PM 10 lavere enn grense på {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 høyere enn",
  "alerts.pm1GreaterThanThreshold": "PM 1 høyere enn grense på {value}{unit}",
  "alerts.pm1LessThan": "PM 1 lavere enn",
  "alerts.pm1LessThanThreshold": "PM 1 lavere enn grense på {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 høyere enn",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 høyere enn grense på {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 lavere enn",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 lavere enn grense på {value}{unit}",
  "alerts.postStormSummary": "Oppsummering etter regn",
  "alerts.postStormSynopsisHelper": "Du får et oppsummeringsvarsel hver gang en regnbyge er over.",
  "alerts.postStormSynopsisSoleCondition": "En oppsummering etter regn kan ikke kombineres med andre betingelser.",
  "alerts.precipitationGreaterThan": "Nedbør per time større enn",
  "alerts.precipitationGreaterThanThreshold": "Nedbør per time over grensen på {value}{unit}",
  "alerts.pressureGreaterThan": "Lufttrykk høyere enn",
  "alerts.pressureGreaterThanThreshold": "Lufttrykk høyere enn grense på {value}{unit}",
  "alerts.pressureLessThan": "Lufttrykk lavere enn",
  "alerts.pressureLessThanThreshold": "Lufttrykk lavere enn grense på {value}{unit}",
  "alerts.rainRateGreaterThan": "Regnintensitet større enn",
  "alerts.rainRateGreaterThanThreshold": "Regnintensitet over grensen på {value}{unit}",
  "alerts.sensorNotReporting": "Denne sensoren sender ikke data akkurat nå. Varselet fortsetter når den sender igjen.",
  "alerts.soilMoistureGreaterThan": "Jordfuktighet høyere enn",
  "alerts.soilMoistureGreaterThanThreshold": "Jordfuktighet høyere enn grense på {value}{unit}",
  "alerts.soilMoistureLessThan": "Jordfuktighet lavere enn",
  "alerts.soilMoistureLessThanThreshold": "Jordfuktighet lavere enn grense på {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Solstråling høyere enn",
  "alerts.solarRadiationGreaterThanThreshold": "Solstråling høyere enn grense på {value}{unit}",
  "alerts.solarRadiationLessThan": "Solstråling lavere enn",
  "alerts.solarRadiationLessThanThreshold": "Solstråling lavere enn grense på {value}{unit}",
  "alerts.stormChartUnavailable": "Regnhistorikk for dette regnværet er ikke tilgjengelig.",
  "alerts.stormDetail": "Oppsummering av regnvær",
  "alerts.stormDuration": "Varighet",
  "alerts.stormEnd": "Slutt",
  "alerts.stormPeakRate": "Maksimal regnintensitet",
  "alerts.stormStart": "Start",
  "alerts.stormTotal": "Total nedbør",
  "alerts.temperatureGreaterThan": "Temperatur høyere enn",
  "alerts.temperatureGreaterThanThreshold": "Temperatur høyere enn grense på {value}{unit}",
  "alerts.temperatureLessThan": "Temperatur lavere enn",
  "alerts.temperatureLessThanThreshold": "Temperatur lavere enn grense på {value}{unit}",
  "alerts.thresholdOutOfRange": "Må være mellom {min} og {max}",
  "alerts.thswGreaterThan": "THSW høyere enn",
  "alerts.thswGreaterThanThreshold": "THSW høyere enn grense på {value}{unit}",
  "alerts.thswLessThan": "THSW lavere enn",
  "alerts.thswLessThanThreshold": "THSW lavere enn grense på {value}{unit}",
  "alerts.thwGreaterThan": "THW høyere enn",
  "alerts.thwGreaterThanThreshold": "THW høyere enn grense på {value}{unit}",
  "alerts.thwLessThan": "THW lavere enn",
  "alerts.thwLessThanThreshold": "THW lavere enn grense på {value}{unit}",
  "alerts.triggerHistory": "Alarmhistorikk",
  "alerts.uvGreaterThan": "UV-indeks høyere enn",
  "alerts.uvGreaterThanThreshold": "UV-indeks høyere enn grense på {value}{unit}",
  "alerts.uvLessThan": "UV-indeks lavere enn",
  "alerts.uvLessThanThreshold": "UV-indeks mindre enn grense på {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Sikt bedre enn grense på {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Sikt dårligere enn grense på {value}{unit}",
  "alerts.visiblityGreaterThan": "Sikt bedre enn",
  "alerts.visiblityLessThan": "Sikt dårligere enn",
  "alerts.whichMeasure": "Hvilke målinger vil du bli varslet for?",
  "alerts.whichModule": "Hvilken modul vil du bli varslet om?",
  "alerts.whichSensor": "Hvilken sensor vil du bli varslet om?",
  "alerts.windChillGreaterThan": "Vindavkjøling høyere enn",
  "alerts.windChillGreaterThanThreshold": "Vindavkjøling høyere enn grense på {value}{unit}",
  "alerts.windChillLessThan": "Vindavkjøling lavere enn",
  "alerts.windChillLessThanThreshold": "Vindavkjøling lavere enn grense på {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vindhastigheten er høyere enn",
  "alerts.windSpeedGreaterThanThreshold": "Vindhastigheten er høyere enn grense på {value}{unit}",
  "alerts.windSpeedLessThan": "Vindhastigheten er lavere enn",
  "alerts.windSpeedLessThanThreshold": "Vindhastighet er lavere enn grense på {value}{unit}",
  "appUpdate.updateAvailable": "Oppdatering tilgjengelig",
  "appUpdate.updateAvailableOpenAppStore": "Trykk for å åpne App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Trykk for å åpne Google Play",
  "appUpdate.updateAvailableVersion": "Oppdatering tilgjengelig: v{version}",
  "appUpdate.upgradeRequiredAndroid": "En oppgradering av app er nødvendig. Gå til Google Play for å oppgradere.",
  "appUpdate.upgradeRequiredIos": "En oppgradering av app er nødvendig. Gå til App Store for å oppgradere.",
  "astral.aboveHorizonAllDay": "Over horisonten hele dagen",
  "astral.aboveTheHorizon": "over horisonten",
  "astral.apparentSize": "Vinkelstørrelse",
  "astral.apparentSizeAcross": "{size} i diameter",
  "astral.astronomicalDawn": "Astronomisk morgengry",
  "astral.astronomicalDusk": "Astronomisk skumring",
  "astral.belowHorizonAllDay": "Under horisonten hele dagen",
  "astral.belowHorizonSince": "Under horisonten siden kl. {time}",
  "astral.belowHorizonSinceOn": "Under horisonten siden {day} kl. {time}",
  "astral.brightAllNight": "Lyst hele natten — aldri helt mørkt",
  "astral.brightestMoment": "Lyseste øyeblikk",
  "astral.civilDawn": "Borgerlig morgengry",
  "astral.civilDusk": "Borgerlig skumring",
  "astral.darkSkyBetween": "Mørk himmel {from} → {to}",
  "astral.darkSkyWindow": "Mørk himmel {from} → {to} · {duration} uten måne",
  "astral.dayLength": "Daglengde",
  "astral.daylightThroughTheYear": "Daglengde gjennom året",
  "astral.dayOfCycle": "dag {day} av {total}",
  "astral.doesNotOccurToday": "Skjer ikke i dag",
  "astral.domeHint": "Dra for å gå gjennom natten",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Tidligste soloppgang",
  "astral.earliestSunset": "Tidligste solnedgang",
  "astral.equinox": "Jevndøgn",
  "astral.equinoxIn": "Jevndøgn om {days, plural, one {# dag} other {# dager}}",
  "astral.evening": "Kveld",
  "astral.exactPhaseAt": "Nøyaktig kl. {time}",
  "astral.firstQuarter": "Første kvarter",
  "astral.firstSunriseIn": "Første soloppgang om {days, plural, one {# dag} other {# dager}}",
  "astral.firstSunsetIn": "Første solnedgang om {days, plural, one {# dag} other {# dager}}",
  "astral.fullMoon": "Fullmåne",
  "astral.goldenHourBegins": "Den gylne timen begynner",
  "astral.goldenHourEnds": "Den gylne timen slutter",
  "astral.highestPoint": "Høyeste punkt",
  "astral.inDays": "om {days, plural, one {# dag} other {# dager}}",
  "astral.lastQuarter": "Siste kvarter",
  "astral.latestSunrise": "Seneste soloppgang",
  "astral.latestSunset": "Seneste solnedgang",
  "astral.litShort": "Belyst",
  "astral.longestDay": "Lengste dag",
  "astral.lowestPoint": "Laveste punkt",
  "astral.maxAltitudeShort": "Maks.",
  "astral.midday": "Midt på dagen",
  "astral.midnightSun": "Midnattssol",
  "astral.midnightSunPeriod": "Midnattssol",
  "astral.milestoneFootnotePolar": "Her står sola verken opp eller går ned {days, plural, one {# dag} other {# dager}} i året, så i stedet for de vanlige ytterpunktene for soloppgang og solnedgang viser lista når det skjer.",
  "astral.milestoneFootnoteTemperate": "Den tidligste solnedgangen og den seneste soloppgangen faller ikke på den korteste dagen — det er tidsjevningen, ikke solvervet, som bestemmer de to datoene.",
  "astral.moon": "Måne",
  "astral.moonAltitude": "Høyde",
  "astral.moonDirection": "Asimut",
  "astral.moonDistance": "Avstand",
  "astral.moonlessFor": "{duration} uten måne",
  "astral.moonPhases": "Månefaser",
  "astral.moonrise": "Måneoppgang",
  "astral.moonset": "Månenedgang",
  "astral.moonUpAllNight": "Månen er oppe hele natten",
  "astral.moonWashesOutNight": "Månen er oppe fra {rise} til {set} og lyser opp hele natten",
  "astral.morning": "Morgen",
  "astral.nauticalDawn": "Nautisk morgengry",
  "astral.nauticalDusk": "Nautisk skumring",
  "astral.newMoon": "Nymåne",
  "astral.nextDay": "+1 dag",
  "astral.nextProperlyDarkNight": "Neste virkelig mørke natt",
  "astral.nextRise": "neste oppgang kl. {time}",
  "astral.nextRiseOn": "neste oppgang {day} kl. {time}",
  "astral.nextSevenNights": "De neste sju nettene",
  "astral.noAstronomicalDarknessTonight": "Ingen astronomisk mørke i natt",
  "astral.noDarkNightAhead": "Ingen de neste to ukene",
  "astral.noSunriseToday": "Ingen soloppgang i dag",
  "astral.nowAtBearing": "nå {altitude} · asimut {direction}",
  "astral.observing": "Observasjon",
  "astral.ofDaylightLeft": "dagslys igjen",
  "astral.overTheNextThreeWeeks": "i løpet av de neste 3 ukene",
  "astral.percentLit": "{percent} opplyst",
  "astral.polarNight": "Mørketid",
  "astral.polarNightPeriod": "Mørketid",
  "astral.rightNow": "Akkurat nå",
  "astral.riseShort": "Opp",
  "astral.setShort": "Ned",
  "astral.shortestDay": "Korteste dag",
  "astral.solarNoon": "Sann middag",
  "astral.solstice": "Solverv",
  "astral.sunBelowHorizon": "Sola {degrees}° under horisonten",
  "astral.sunEvents": "Solhendelser",
  "astral.sunNeverDarkEnough": "Sola kommer aldri 18° under horisonten",
  "astral.sunNeverSets": "Sola går ikke ned",
  "astral.sunrise": "Soloppgang",
  "astral.sunriseAndSunset": "Soloppgang og solnedgang",
  "astral.sunriseAt": "Soloppgang kl. {time}",
  "astral.sunset": "Solnedgang",
  "astral.sunsetAt": "Solnedgang kl. {time}",
  "astral.thisYearAtNorth": "I år på {degrees}° N",
  "astral.thisYearAtSouth": "I år på {degrees}° S",
  "astral.tonight": "I natt",
  "astral.twilightAllNight": "Tussmørke hele natten — aldri helt mørkt",
  "astral.upFor": "{duration} over horisonten",
  "astral.usableLight": "Brukbart lys",
  "astral.vsAverage": "{percent} mot snittet",
  "astral.vsYesterday": "mot i går",
  "astral.waningCrescent": "Avtagende månesigd",
  "astral.waningGibbous": "Avtagende trekvartmåne",
  "astral.waxingCrescent": "Voksende månesigd",
  "astral.waxingGibbous": "Voksende trekvartmåne",
  "astral.whereToLook": "Hvor du skal se",
  "astral.withoutTheMoon": "{duration} uten måne",
  "auth.alreadyHaveAccount": "Har du allerede en konto?",
  "auth.authContainerTagline": "Ditt personlige værdashbord. Koble til stasjonene dine og få sanntidsdata rett ved fingertuppene.",
  "auth.backToLogin": "Tilbake til innlogging",
  "auth.checkYourEmail": "Sjekk e-posten din",
  "auth.continueWithApple": "Fortsett med Apple",
  "auth.continueWithFacebook": "Fortsett med Facebook",
  "auth.continueWithGoogle": "Fortsett med Google",
  "auth.email": "E-postadresse",
  "auth.emailRequiredLoginFacebook": "E-posttillatelse kreves.",
  "auth.emailVerification": "Epostbekreftelse",
  "auth.emailVerificationFailure": "Det oppstod et problem med E-postbekreftelsen din.",
  "auth.emailVerificationSuccess": "E-posten din har blitt bekreftet.",
  "auth.firstName": "Fornavn",
  "auth.forgotPassword": "Glemt passord?",
  "auth.forgotPasswordSubtitle": "Skriv inn e-postadressen din, så sender vi deg en lenke for å tilbakestille passordet.",
  "auth.lastName": "Etternavn",
  "auth.login": "Logg inn",
  "auth.loginSubtitle": "Velkommen tilbake! Vennligst skriv inn opplysningene dine.",
  "auth.loginToSmartMixinDescription": "Logg inn på SmartMixin for å få tilgang til værstasjonene dine, se analyser og administrere ditt personlige værdashbord.",
  "auth.logout": "Logg ut",
  "auth.logoutConfirmation": "Vil du logge ut?",
  "auth.noAccountYet": "Har du ikke en konto ennå?",
  "auth.or": "eller",
  "auth.password": "Passord",
  "auth.passwordReset": "Tilbakestill passord",
  "auth.passwordResetSuccess": "Passordet ditt er oppdatert.",
  "auth.register": "Opprett konto",
  "auth.registerDescription": "Opprett en gratis SmartMixin-konto for å koble til værstasjonene dine, følge værdata og få tilgang til avanserte analyseverktøy.",
  "auth.registerSubtitle": "Opprett kontoen din for å komme i gang.",
  "auth.restorePassword": "Gjenopprett passord",
  "auth.restorePasswordSuccess": "Vi har sendt en kobling for tilbakestilling av passord til {emailAddress} med ytterligere instruksjoner.",
  "auth.sendReset": "Send tilbakestillingsinstruksjoner",
  "auth.signInWithApple": "Logg på med Apple",
  "auth.socialAccount": "eller bruk kontoen din",
  "auth.staffVerificationCode": "Bekreftelseskode",
  "auth.staffVerificationExpiresIn": "Bekreftet. Utløper om {duration}.",
  "auth.staffVerificationInvalidCode": "Feil kode. Prøv igjen.",
  "auth.staffVerificationLoginAsStopped": "Login As ble stoppet: skriv inn en bekreftelseskode på Debug-skjermen for å fortsette.",
  "auth.staffVerificationNotEnrolled": "Ingen autentiseringsapp er satt opp for kontoen din. Legg til en i sikkerhetsinnstillingene i back office.",
  "auth.staffVerificationPrompt": "Skriv inn den 6-sifrede koden fra autentiseringsappen din, eller en gjenopprettingskode, for å bruke Login As og brukersøk.",
  "auth.staffVerificationSetupLink": "Legg til en autentiseringsapp",
  "auth.staffVerificationSubmit": "Bekreft",
  "auth.staffVerificationTitle": "Personalbekreftelse",
  "calendar.afternoon": "Ettermiddag",
  "calendar.april": "April",
  "calendar.august": "August",
  "calendar.changePeriod": "Periode: {period}. Endre periode",
  "calendar.currentDay": "Gjeldende dag",
  "calendar.dateFormat": "Datoformat",
  "calendar.day": "Dag",
  "calendar.december": "Desember",
  "calendar.durationHours": "{hours} t",
  "calendar.durationHoursMinutes": "{hours} t {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.end": "Slutt",
  "calendar.endTime": "Sluttid",
  "calendar.evening": "Kveld",
  "calendar.february": "Februar",
  "calendar.goToNextDay": "Neste dag",
  "calendar.goToNextMonth": "Neste måned",
  "calendar.goToNextWeek": "Neste uke",
  "calendar.goToNextYear": "Neste år",
  "calendar.goToPreviousDay": "Forrige dag",
  "calendar.goToPreviousMonth": "Forrige måned",
  "calendar.goToPreviousWeek": "Forrige uke",
  "calendar.goToPreviousYear": "Forrige år",
  "calendar.hour": "Time",
  "calendar.hoursCount": "{count, plural, one {# time} other {# timer}}",
  "calendar.hoursShort": "t",
  "calendar.hoursShortCount": "{count, plural, one {# t} other {# t}}",
  "calendar.january": "Januar",
  "calendar.july": "Juli",
  "calendar.june": "Juni",
  "calendar.last12Hours": "Siste 12 timer",
  "calendar.last24Hours": "Siste 24 timer",
  "calendar.last30Days": "Siste 30 døgn",
  "calendar.last3Hours": "Siste 3 timer",
  "calendar.last6Hours": "Siste 6 timer",
  "calendar.last7Days": "Siste 7 døgn",
  "calendar.lastHour": "Siste time",
  "calendar.march": "Mars",
  "calendar.max": "Maks",
  "calendar.may": "Mai",
  "calendar.month": "Måned",
  "calendar.monthTotal": "Måned totalt",
  "calendar.morning": "Morgen",
  "calendar.nextHours": "Neste timer",
  "calendar.night": "Natt",
  "calendar.november": "November",
  "calendar.october": "Oktober",
  "calendar.oneDay": "1 dag",
  "calendar.oneHour": "1 time",
  "calendar.oneMonth": "1 måned",
  "calendar.oneWeek": "1 uke",
  "calendar.periodRangeSpoken": "{start} til {end}",
  "calendar.previous24Hours": "Foregående 24 timer",
  "calendar.previous30Days": "Foregående 30 døgn",
  "calendar.previous7Days": "Foregående 7 døgn",
  "calendar.previousDay": "Forrige dag",
  "calendar.previousHours": "Tidligere timer",
  "calendar.previousMonth": "Forrige måned",
  "calendar.previousWeek": "Forrige uke",
  "calendar.previousYear": "Forrige år",
  "calendar.sameDayLastYear": "Samme dag i fjor",
  "calendar.sameMonthLastYear": "Samme måned i fjor",
  "calendar.selectADate": "Velg en dato",
  "calendar.selectAggregation": "Velg vist verdi",
  "calendar.selectAMonth": "Velg en måned",
  "calendar.selectAYear": "Velg et år",
  "calendar.selectGranularity": "Velg detaljrikdom",
  "calendar.selectPeriod": "Velg en periode",
  "calendar.september": "September",
  "calendar.sixHours": "6 timer",
  "calendar.start": "Start",
  "calendar.startTime": "Starttid",
  "calendar.thirtyMinutes": "30 minutter",
  "calendar.threeHours": "3 timer",
  "calendar.timezone": "Tidssone",
  "calendar.today": "I dag",
  "calendar.untilChanged": "Inntil endret",
  "calendar.untilTime": "Frem til {time}",
  "calendar.untilTodayAt": "Frem til i dag kl. {time}",
  "calendar.untilTomorrowAt": "Frem til i morgen kl. {time}",
  "calendar.use24HourFormat": "Bruk 24 timers format",
  "calendar.week": "Uke",
  "calendar.year": "År",
  "calendar.yearToDate": "Hittil i år",
  "calendar.yesterday": "I går",
  "charts.averageOverThePeriod": "Gjennomsnitt for perioden",
  "charts.calendarView": "Kalendervisning",
  "charts.charts": "Diagram",
  "charts.chartView": "Diagramvisning",
  "charts.comparison": "Sammenligning",
  "charts.customizeComparisonMetrics": "Tilpass målinger",
  "charts.customizeComparisonMetricsDescription": "Dra elementer for å omorganisere sammenligningsmetrikker. Trykk på øyeikonet for å vise eller skjule målinger.",
  "charts.maxOverThePeriod": "Maksimum for perioden",
  "charts.measureToDisplay": "Målinger å vise",
  "charts.minMaxRange": "Min. / Maks.",
  "charts.noDataForThisPeriod": "Ingen data for denne perioden",
  "charts.observations": "Observasjoner",
  "charts.observedTemperature": "Målt temperatur",
  "charts.showComparison": "Vis sammenligning",
  "charts.stationComparison": "Stasjonssammenligning",
  "charts.stationComparisonDescription": "Sammenlign historiske værdata med en annen stasjon",
  "charts.sumOverThePeriod": "Sum for perioden",
  "charts.viewAsList": "Liste",
  "charts.viewAsPeriods": "Perioder",
  "common.add": "Legg til",
  "common.altitude": "Høyde",
  "common.analysis": "Analyse",
  "common.average": "Gjennomsnitt",
  "common.back": "Tilbake",
  "common.backToHome": "Tilbake til forsiden",
  "common.cancel": "Avbryt",
  "common.cannotBeEmpty": "Dette feltet kan ikke være tomt.",
  "common.close": "Lukk",
  "common.dailyForecast": "Dagsvarsel",
  "common.default": "Standard",
  "common.delete": "Slett",
  "common.details": "Detaljer",
  "common.edit": "Rediger",
  "common.exitFullscreen": "Avslutt fullskjerm",
  "common.forecast": "Prognose",
  "common.frequency": "Frekvens",
  "common.full": "Full",
  "common.fullscreen": "Fullskjerm",
  "common.help": "Hjelp",
  "common.hidden": "Skjulte",
  "common.high": "Høy",
  "common.iDontKnowYet": "Jeg vet ikke ennå",
  "common.indoor": "Innendørs",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Siste oppdatering",
  "common.low": "Lav",
  "common.maximum": "Maksimum",
  "common.medium": "Middels",
  "common.minimum": "Minimum",
  "common.more": "Mer",
  "common.moreInformation": "Mer informasjon",
  "common.next": "Neste",
  "common.no": "Nei",
  "common.noAccountNeeded": "Ingen konto nødvendig",
  "common.noItemsAvailable": "Ingen elementer tilgjengelig",
  "common.notNow": "Ikke nå",
  "common.now": "Nå",
  "common.numberOfActiveWarnings": "{warning_count, plural, one {# aktivt farevarsel} other {# aktive farevarsler}}",
  "common.openSettings": "Åpne innstillinger",
  "common.outdoor": "Utendørs",
  "common.pageNotFound": "Side ikke funnet",
  "common.pageNotFoundDescription": "Siden du leter etter finnes ikke eller har blitt flyttet.",
  "common.rain": "Regn",
  "common.share": "Del",
  "common.shareImageFailed": "Kunne ikke dele bildet",
  "common.shareYourWeather": "Del været ditt",
  "common.skip": "Hopp over",
  "common.start": "Start",
  "common.unknown": "Ukjent",
  "common.validate": "Bekreft",
  "common.validEmail": "En gyldig e-postadresse kreves.",
  "common.very_low": "Veldig lav",
  "common.weatherObservations": "Værobservasjoner",
  "common.welcome": "Velkommen til SmartMixin!",
  "common.wind": "Vind",
  "common.yes": "Ja",
  "common.zoomImage": "Forstørr bildet",
  "compass.E": "Ø",
  "compass.E_long": "Øst",
  "compass.ENE": "ØNØ",
  "compass.ENE_long": "Øst-Nordøst",
  "compass.ESE": "ØSØ",
  "compass.ESE_long": "Øst-Sørøst",
  "compass.N": "N",
  "compass.N_long": "Nord",
  "compass.NE": "NØ",
  "compass.NE_long": "Nordøst",
  "compass.NNE": "NNØ",
  "compass.NNE_long": "Nord-Nordøst",
  "compass.NNW": "NNV",
  "compass.NNW_long": "Nord-Nordvest",
  "compass.NW": "NV",
  "compass.NW_long": "Nordvest",
  "compass.S": "S",
  "compass.S_long": "Sør",
  "compass.SE": "SØ",
  "compass.SE_long": "Sørøst",
  "compass.SSE": "SSØ",
  "compass.SSE_long": "Sør-Sørøst",
  "compass.SSW": "SSV",
  "compass.SSW_long": "Sør-Sørvest",
  "compass.SW": "SV",
  "compass.SW_long": "Sørvest",
  "compass.W": "V",
  "compass.W_long": "Vest",
  "compass.WNW": "VNV",
  "compass.WNW_long": "Vest-Nordvest",
  "compass.WSW": "VSV",
  "compass.WSW_long": "Vest-Sørvest",
  "dashboard.currentObservations": "Siste måling",
  "dashboard.currentRainEvent": "Nåværende regnhendelse",
  "dashboard.currentWeatherConditions": "Været nå",
  "dashboard.customizeDashboard": "Tilpass",
  "dashboard.customizeDashboardDescription": "Dra elementer for å endre rekkefølgen på dashbordet. Trykk på øyeikonet for å vise eller skjule seksjoner.",
  "dashboard.dashboard": "Dashboard",
  "dashboard.dayRangeExpected": "{value} forventet kl. {time}",
  "dashboard.dayRangeReached": "{value} kl. {time}",
  "dashboard.dayRangeSteady": "Stabilt {value} hele dagen",
  "dashboard.hiddenSensors": "Skjulte sensorer",
  "dashboard.lastRainEvent": "Siste regnhendelse",
  "dashboard.manageSensors": "Administrer sensorer",
  "dashboard.manageSensorsDescription": "Dra elementer for å endre rekkefølgen på sensorer. Trykk på øyeikonet for å vise eller skjule sensorer. Trykk på et navn for å gi det nytt navn.",
  "dashboard.pressureSummary": "Trykkoppsummering",
  "dashboard.rainEvents": "Regnhendelser",
  "dashboard.rainSummary": "Regnoppsummering",
  "dashboard.shareOutdoorMeasures": "Del dine utendørsmålinger",
  "dashboard.shareOutdoorMeasuresDescription": "Delta i SmartMixin samfunnet ved å gjøre dine utendørsmålinger synlige for andre. Innendørsmålinger vil ikke bli delt.",
  "dashboard.temperatureSummary": "Temperaturoppsummering",
  "dashboard.windSummary": "Vindoppsummering",
  "devices.batteryLevel": "Batterinivå",
  "devices.firmwareVersion": "Firmwareversjon",
  "devices.moduleCount": "{count, plural, one {# modul} other {# moduler}}",
  "devices.moduleType": "Modultype",
  "devices.noNetatmoWeatherStationYet": "Du har ikke en Netatmo-værstasjon ennå.",
  "devices.noOutdoorModule": "Det er ingen fungerende utemodul for denne stasjonen.",
  "devices.notReachable": "Ikke tilgjengelig",
  "devices.serialNumber": "Serienummer",
  "devices.signalAverage": "Middels",
  "devices.signalBad": "Svak",
  "devices.signalGood": "God",
  "devices.signalStrength": "Signalstyrke",
  "devices.signalUnknown": "Ukjent",
  "devices.visitNetatmoWebsite": "Besøk Netatmo nettsted",
  "devices.wifiStrength": "Wi-Fi-styrke",
  "forecastMaps.addColor": "Legg til farge",
  "forecastMaps.addLayer": "Legg til lag",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Tilbake til kartene",
  "forecastMaps.build": "Generer",
  "forecastMaps.buildCompleted": "Generering fullført",
  "forecastMaps.builderMetaDescription": "Sett sammen egne varselkart fra værmodellenes lag.",
  "forecastMaps.builderTitle": "Kartbygger",
  "forecastMaps.buildFailed": "Genereringen mislyktes. Prøv igjen.",
  "forecastMaps.buildNotPossible": "Dette kartet kan ikke genereres ennå — ingen prognosedata er tilgjengelige.",
  "forecastMaps.buildProgress": "Rendrer… {completed}/{total} trinn",
  "forecastMaps.buildStarting": "Starter generering…",
  "forecastMaps.byModel": "Etter modell",
  "forecastMaps.byZone": "Etter sone",
  "forecastMaps.colormap": "Fargeskala",
  "forecastMaps.colormapCustom": "Egendefinerte farger",
  "forecastMaps.colormapGroupDomain": "Værforvalg",
  "forecastMaps.colormapGroupMatplotlib": "Vitenskapelige forvalg",
  "forecastMaps.colorScale": "Fargeskala",
  "forecastMaps.contourLevels": "Konturnivåer",
  "forecastMaps.countryCanada": "Canada",
  "forecastMaps.countryFrance": "Frankrike",
  "forecastMaps.countryGermany": "Tyskland",
  "forecastMaps.countryItaly": "Italia",
  "forecastMaps.countryScandinavia": "Skandinavia",
  "forecastMaps.countrySpain": "Spania",
  "forecastMaps.countrySwitzerland": "Sveits",
  "forecastMaps.countryUnitedStates": "USA",
  "forecastMaps.customColormapMinColors": "En egendefinert fargeskala krever minst to farger",
  "forecastMaps.customExtent": "Egendefinert utsnitt",
  "forecastMaps.displayName": "Visningsnavn",
  "forecastMaps.downscaling": "Uttynningsfaktor for vindpiler",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Tegn område",
  "forecastMaps.east": "Øst",
  "forecastMaps.extentDrawHint": "Dra på kartet for å tegne området",
  "forecastMaps.extentInvalid": "Vest må være mindre enn øst, og sør mindre enn nord",
  "forecastMaps.height": "Høyde (tommer)",
  "forecastMaps.hourOffset": "+{hour} t",
  "forecastMaps.invalidHexColor": "Ugyldig farge — bruk #RRGGBB",
  "forecastMaps.layers": "Lag",
  "forecastMaps.layerTypeBarbs": "Vindpiler",
  "forecastMaps.layerTypeContour": "Konturlinjer",
  "forecastMaps.layerTypeFilledContour": "Fylte konturer",
  "forecastMaps.layerTypeMagnitude": "Størrelse",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektorfelt",
  "forecastMaps.leave": "Forlat",
  "forecastMaps.levelsCount": "Antall",
  "forecastMaps.levelsInvalid": "Ugyldige konturnivåer",
  "forecastMaps.levelsModeArange": "Fast steg",
  "forecastMaps.levelsModeExplicit": "Eksplisitte verdier",
  "forecastMaps.levelsModeLinspace": "Jevnt fordelt (antall)",
  "forecastMaps.levelsStep": "Steg",
  "forecastMaps.levelsValues": "Verdier",
  "forecastMaps.levelsValuesHint": "Kommaseparerte, stigende",
  "forecastMaps.localTimeHint": "Vist i din lokale tid",
  "forecastMaps.mapDescription": "Beskrivelse",
  "forecastMaps.mapName": "Kartnavn",
  "forecastMaps.mapNameRequired": "Skriv inn et navn",
  "forecastMaps.mapSettings": "Kartinnstillinger",
  "forecastMaps.mapView": "Interaktivt kart",
  "forecastMaps.maxLayersReached": "Dette kartet har nådd maksimum på {max} lag.",
  "forecastMaps.maxValue": "Maksverdi",
  "forecastMaps.memoryBudgetExceeded": "Oppløsningen overskrider renderingsbudsjettet — reduser DPI eller høyde",
  "forecastMaps.memoryBudgetUsage": "Renderingsbudsjett: {percent}%",
  "forecastMaps.metaDescription": "Animerte varselkart generert fra værmodellenes kjøringer.",
  "forecastMaps.metric": "Måling",
  "forecastMaps.metricRequired": "Velg en måling",
  "forecastMaps.metricUnavailable": "Ikke tilgjengelig for denne modellen",
  "forecastMaps.minBelowMax": "Min må være mindre enn maks",
  "forecastMaps.minMaxRequired": "Min- og maksverdier kreves for denne lagtypen",
  "forecastMaps.minValue": "Minverdi",
  "forecastMaps.modelNoRun": "Ingen fullført kjøring ennå",
  "forecastMaps.moveLayerDown": "Flytt ned",
  "forecastMaps.moveLayerUp": "Flytt opp",
  "forecastMaps.myMaps": "Mine kart",
  "forecastMaps.nanClipToMin": "Begrens til min",
  "forecastMaps.nanMask": "Masker",
  "forecastMaps.nanPolicy": "Manglende data",
  "forecastMaps.nanSkip": "Hopp over",
  "forecastMaps.noCompletedRun": "Dette kartet er ikke generert ennå. Kom tilbake snart.",
  "forecastMaps.noLayers": "Ingen lag ennå. Legg til et lag for å komme i gang.",
  "forecastMaps.noMapsAvailable": "Ingen varselkart er tilgjengelige ennå.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Opasitet",
  "forecastMaps.overlayLegend": "Tegnforklaring",
  "forecastMaps.pause": "Pause",
  "forecastMaps.play": "Spill av",
  "forecastMaps.pointValueError": "Kunne ikke laste inn prognosen for dette punktet.",
  "forecastMaps.pointValueLoading": "Laster inn prognose…",
  "forecastMaps.pointValueUnavailable": "Ingen data for dette tidspunktet.",
  "forecastMaps.presets": "Forvalg",
  "forecastMaps.preview": "Forhåndsvisning",
  "forecastMaps.previewEmptyHint": "Konfigurer minst ett gyldig lag for å rendre en forhåndsvisning.",
  "forecastMaps.previewFailed": "Forhåndsvisningen mislyktes",
  "forecastMaps.previewHour": "Prognosetime",
  "forecastMaps.previewRendering": "Rendrer forhåndsvisning…",
  "forecastMaps.projection": "Projeksjon",
  "forecastMaps.projectionLambertConformal": "Lambert konform",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografisk",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Nord-Amerika",
  "forecastMaps.removeColor": "Fjern farge",
  "forecastMaps.removeLayer": "Fjern lag",
  "forecastMaps.retry": "Prøv igjen",
  "forecastMaps.run": "Kjøring: {run}",
  "forecastMaps.save": "Lagre",
  "forecastMaps.selectExtentOnMap": "Velg område på kartet",
  "forecastMaps.south": "Sør",
  "forecastMaps.title": "Varselkart",
  "forecastMaps.uMetric": "U-komponent",
  "forecastMaps.unitConversion": "Enhetskonvertering",
  "forecastMaps.unitNone": "Ingen",
  "forecastMaps.unsavedChangesBody": "Du har ulagrede endringer. Forlate og forkaste dem?",
  "forecastMaps.unsavedChangesTitle": "Ulagrede endringer",
  "forecastMaps.useCurrentView": "Bruk gjeldende visning",
  "forecastMaps.useModelDomain": "Av: hele modellens domene brukes",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U- og V-målinger må være forskjellige",
  "forecastMaps.valueBetween": "Må være mellom {min} og {max}",
  "forecastMaps.variable": "Variabel",
  "forecastMaps.viewMap": "Vis kart",
  "forecastMaps.vMetric": "V-komponent",
  "forecastMaps.west": "Vest",
  "forecastMaps.windAnimation": "Vindanimasjon",
  "forecastModels.addForecastModel": "Legg til en modell",
  "forecastModels.atYourStations": "Tilgjengelige ved stasjonene dine",
  "forecastModels.coverageLoading": "Regner ut hvilke av stasjonene dine hver modell dekker…",
  "forecastModels.description_AROME": "Météo Frances konveksjonsoppløsende høyoppløselige modell over Vest-Europa med 1,3 km oppløsning. Best i klassen for kortsiktige prognoser i Frankrike; oppdatert hver tredje time.",
  "forecastModels.description_ARPEGE_EU": "Météo Frances nestede europeiske domene av ARPEGE-modellen med 10 km oppløsning. Mellomlangs varsel over Europa, oppdatert fire ganger daglig.",
  "forecastModels.description_ARPEGE_GLOBAL": "Météo Frances globale numeriske værmodell med 25 km oppløsning, som kjører opp til ca. 4 dager. Oppdatert fire ganger daglig.",
  "forecastModels.description_DMI_DINI": "DMIs HARMONIE DINI: en konveksjonsoppløsende modell over det nordvestlige Europa — Danmark, Benelux, Irland, Storbritannia og Skandinavia — med 2 km oppløsning som kjører opp til 60 timer, oppdatert åtte ganger daglig. Inneholder modifiserte åpne data fra DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Environment Canadas Global Deterministic Prediction System: en verdensomspennende mellomlangs modell med 15 km oppløsning som kjører opp til 10 dager, oppdatert to ganger daglig.",
  "forecastModels.description_EC_HRDPS": "Environment Canadas High Resolution Deterministic Prediction System: en konveksjonsoppløsende modell over Canada og det nordlige USA med 2,5 km oppløsning som kjører opp til 48 timer, oppdatert fire ganger daglig.",
  "forecastModels.description_EC_RDPS": "Environment Canadas Regional Deterministic Prediction System: en mellomlangs modell over Nord-Amerika med 10 km oppløsning, oppdatert fire ganger daglig.",
  "forecastModels.description_ECMWF_HRES": "Flaggskipmodellen med høy oppløsning (IFS) fra Det europeiske senteret for mellomlange værvarsler, bredt ansett som verdens ledende globale varslingssystem. Dekker hele planeten med 25 km oppløsning opptil 15 dager, oppdateres fire ganger daglig. Inneholder modifiserte åpne data fra ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "NOAAs flaggskip mellomlangs globale modell. Dekker hele planeten med 25 km oppløsning opp til 16 dager, oppdatert fire ganger daglig.",
  "forecastModels.description_HRRR_CONUS": "NOAAs High-Resolution Rapid Refresh: en konveksjonsoppløsende modell over det kontinentale USA med 3 km oppløsning, oppdatert hver time. Best egnet for veldig kortsiktige prognoser for tordenvær og hardt vær.",
  "forecastModels.description_ICON": "DWDs globale ICON-modell med 13 km oppløsning som dekker hele planeten opptil 7,5 dager, oppdatert fire ganger daglig. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ItaliaMeteos ICON-2I, drevet sammen med ARPAE: en konveksjonsoppløsende modell over Italia med 2,2 km oppløsning som kjører opp til 72 timer, oppdatert to ganger daglig. Inneholder åpne data fra ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "MeteoSwiss' ICON-CH1-EPS-kontrollkjøring: en konveksjonsoppløsende modell over Alpene med 1 km oppløsning som kjører opp til 33 timer, oppdatert hver tredje time.",
  "forecastModels.description_ICON_CH2": "MeteoSwiss' ICON-CH2-EPS-kontrollkjøring: en konveksjonsoppløsende modell over Alpene — Sveits og den omkringliggende alperegionen — med 2,1 km oppløsning som kjører opp til 120 timer, oppdatert fire ganger daglig.",
  "forecastModels.description_ICON_DE": "DWDs høyoppløselige konveksjonsoppløsende modell over Tyskland og omkringliggende land med 2,2 km oppløsning. Kortsiktige prognoser oppdatert to ganger daglig. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "DWDs nestede europeiske domene av ICON-modellen med 7 km oppløsning som dekker Europa og Nord-Atlanteren. Mellomlangs varsel oppdatert fire ganger daglig. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Det Norske Meteorologiske Institutts åpne værvarslingstjeneste, som blander høyoppløselige nordiske modeller med ECMWF-data for å gi verdensomspennende varsler opp til 10 dager frem.",
  "forecastModels.description_MF_AROME_ANTILLES": "Nestet AROME-domene over de franske Antillene (Guadeloupe, Martinique) med 2,5 km oppløsning. Kortsiktige prognoser oppdatert fire ganger daglig.",
  "forecastModels.description_MF_AROME_GUYANE": "Nestet AROME-domene over Fransk Guyana med 2,5 km oppløsning. Kortsiktige prognoser oppdatert fire ganger daglig.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Nestet AROME-domene over Ny-Caledonia med 2,5 km oppløsning. Kortsiktige prognoser oppdatert fire ganger daglig.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Nestet AROME-domene over Fransk Polynesia med 2,5 km oppløsning. Kortsiktige prognoser oppdatert fire ganger daglig.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Nestet AROME-domene over Réunion og Mayotte med 2,5 km oppløsning. Kortsiktige prognoser oppdatert fire ganger daglig.",
  "forecastModels.description_RRFS_CONUS": "NOAAs Rapid Refresh Forecast System over det kontinentale USA med 3 km oppløsning. Timesvarsler oppdatert åtte ganger daglig, opptil 84 timer på de fire hovedkjøringene og 18 timer på de øvrige.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "NOAAs Rapid Refresh Forecast System for hele Nord-Amerika med 13 km oppløsning. Timesvarsler opptil 84 timer, oppdatert fire ganger daglig.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "SmartMixins flaggskipvarsel. For hver time på din plassering velger vi den beste tilgjengelige modellen — vanligvis en høyoppløselig regional modell der det finnes en (AROME i Frankrike, ICON-D2 i Tyskland, HRRR i USA, ARPEGE Europe over kontinentet…) og faller tilbake på en global modell andre steder — og fyller deretter eventuelle hull fra nabokilder. Resultatet er ett enkelt sømløst varsel som dekker hvor som helst i verden opp til 14 dager, automatisk oppdatert hver gang en av de underliggende modellene oppdateres.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Weatherflows proprietære globale varsel som blander flere numeriske værmodeller med observasjoner fra dets Tempest-værstasjonsnettverk. 10-dagers verdensomspennende horisont.",
  "forecastModels.everywhereElse": "Overalt ellers",
  "forecastModels.everywhereElseFoot": "Brukes ved enhver stasjon de foretrukne modellene dine ikke når.",
  "forecastModels.everywhereElsePick": "Velg én",
  "forecastModels.fallbackBlend": "SmartMixin-blanding",
  "forecastModels.fallbackBlendSub": "Kombinerer flere modeller, hver der den er sterkest.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES overalt der den rekker.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "NOAAs globale modell. Det alle kontoer bruker i dag.",
  "forecastModels.fallbackResolution": "Høyeste oppløsning",
  "forecastModels.fallbackResolutionSub": "Det fineste rutenettet som finnes ved hver stasjon.",
  "forecastModels.forecastChipLabelWithRun": "{model}, kjøring {run}",
  "forecastModels.forecastChipRunHint": "Trykk lenge for å vise eller skjule den siste kjøringen",
  "forecastModels.forecastComparisonDescription": "Sammenlign enkelt prognosemodelldata fra flere kilder",
  "forecastModels.forecastFollowingPreferences": "Følger innstillingene dine",
  "forecastModels.forecastModel": "Prognosemodell",
  "forecastModels.forecastModelComparison": "Sammenligning av prognosemodeller",
  "forecastModels.forecastModelCoverage": "Dekning",
  "forecastModels.forecastModelDescription": "Beskrivelse",
  "forecastModels.forecastModels": "Prognosemodeller",
  "forecastModels.forecastModelScopeGlobal": "Global",
  "forecastModels.forecastModelScopeGlobalDescription": "Denne modellen dekker hele kloden.",
  "forecastModels.forecastModelScopeRegional": "Regional",
  "forecastModels.forecastModelScopeRegionalDescription": "Denne modellen dekker kun en bestemt region.",
  "forecastModels.forecastModelSpecifications": "Spesifikasjoner",
  "forecastModels.forecastNoPinLocation": "Ingen foretrukket modell når dette stedet — «overalt ellers» bestemmer.",
  "forecastModels.forecastNoPinStation": "Ingen foretrukket modell når denne stasjonen — «overalt ellers» bestemmer.",
  "forecastModels.forecastNoPreferredModels": "Ingen foretrukne modeller angitt ennå.",
  "forecastModels.forecastOverrideElsewhere": "Innstillingene dine gjelder overalt ellers.",
  "forecastModels.forecastPickForLocation": "Eller velg en for dette stedet",
  "forecastModels.forecastPickForStation": "Eller velg en for denne stasjonen",
  "forecastModels.forecastPinWinsLocation": "{model} — din første foretrukne modell som når dette stedet.",
  "forecastModels.forecastPinWinsStation": "{model} — din første foretrukne modell som når denne stasjonen.",
  "forecastModels.forecastServedNowHere": "Akkurat nå er det {model} her",
  "forecastModels.forecastSetForLocation": "Angitt for dette stedet",
  "forecastModels.forecastSetForStation": "Angitt for denne stasjonen",
  "forecastModels.forecastSettingsRowSub": "Foretrukne modeller, og hva som gjelder overalt ellers",
  "forecastModels.forecastStopUsingHere": "Slutt å bruke her",
  "forecastModels.forecastUseForLocation": "Bruk {model} for dette stedet",
  "forecastModels.forecastUseForStation": "Bruk {model} for denne stasjonen",
  "forecastModels.forecastUsePreferred": "Bruk mine foretrukne modeller",
  "forecastModels.frequencyHourly": "Hver time",
  "forecastModels.horizon": "Gyldighet",
  "forecastModels.horizonValue": "opptil {value} timer",
  "forecastModels.meshSize": "Rutestørrelse",
  "forecastModels.pickerShowAll": "Vis hele katalogen",
  "forecastModels.pickerUnreachable": "{count, plural, one {# modell til når} other {# modeller til når}} ingen av stasjonene dine",
  "forecastModels.pinInUse": "I bruk",
  "forecastModels.pinShadowed": "Brukes aldri — en modell over dekker alle stasjonene dine",
  "forecastModels.pinSlots": "{used} av {max} · velg en modell",
  "forecastModels.pinSlotsFull": "{max, plural, one {Den eneste plassen er i bruk. Fjern modellen for å legge til en annen.} other {Alle # plassene er i bruk. Fjern én for å legge til en annen.}}",
  "forecastModels.pinsUncoveredCount": "{used} av dine {count, plural, one {# stasjon} other {# stasjoner}}: ingen foretrukket modell når {used, plural, one {den} other {dem}} — «overalt ellers» bestemmer.",
  "forecastModels.pinsUncoveredNamed": "{stations}: ingen foretrukket modell når {count, plural, one {den} other {dem}} — «overalt ellers» bestemmer.",
  "forecastModels.pinUnreachable": "Brukes aldri — den når ingen av stasjonene dine",
  "forecastModels.pinUsedAt": "Brukes ved {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Brukes ved stasjonen din} other {Brukes ved alle # stasjoner}}",
  "forecastModels.pinUsedAtSome": "Brukes ved {used} av {count, plural, one {# stasjon} other {# stasjoner}}",
  "forecastModels.preferredModels": "Foretrukne modeller",
  "forecastModels.preferredModelsAll": "Én liste, alle stasjoner",
  "forecastModels.preferredModelsOne": "Én liste, gjelder overalt",
  "forecastModels.publisher": "Utgiver",
  "forecastModels.removePreferredModel": "Fjern {model} fra dine foretrukne modeller",
  "forecastModels.resetForecastPreference": "Tilbakestill til standard",
  "forecastModels.resetForecastPreferenceHint": "Fjerner de foretrukne modellene dine og går tilbake til SmartMixins standard.",
  "forecastModels.servedNowMany": "Akkurat nå: GFS {count, plural, one {ved stasjonen din} other {ved alle # stasjoner}}.",
  "forecastModels.servedNowNone": "Akkurat nå: GFS overalt.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodell",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow-prognose",
  "forecastModels.weatherForecastModels": "Prognosemodeller",
  "helpCenter.articleCount": "{count, plural, one {# artikkel} other {# artikler}}",
  "helpCenter.articleNotFound": "Artikkel ikke funnet",
  "helpCenter.articleNotFoundDescription": "Artikkelen du leter etter finnes ikke.",
  "helpCenter.backToHelpCenter": "Tilbake til hjelpesenteret",
  "helpCenter.browseByCategory": "Bla etter kategori",
  "helpCenter.categoryNotFound": "Kategori ikke funnet",
  "helpCenter.categoryNotFoundDescription": "Denne kategorien finnes ikke eller har ingen artikler.",
  "helpCenter.contactSupport": "Kontakt kundestøtte",
  "helpCenter.feedbackHelpsImprove": "Din tilbakemelding hjelper oss med å forbedre hjelpeartiklene våre.",
  "helpCenter.feedbackReasonNotAnswer": "Den svarer ikke på spørsmålet mitt",
  "helpCenter.feedbackReasonOutdated": "Informasjonen er utdatert",
  "helpCenter.feedbackReasonUnclear": "Instruksjonene er uklare",
  "helpCenter.feedbackWhatWentWrong": "Hva var problemet?",
  "helpCenter.helpCategoryAccount": "Konto",
  "helpCenter.helpCategoryBilling": "Fakturering",
  "helpCenter.helpCategoryForecast": "Prognoser",
  "helpCenter.helpCategoryGettingStarted": "Kom i gang",
  "helpCenter.helpCategoryProviders": "Leverandører",
  "helpCenter.helpCategoryStations": "Stasjoner",
  "helpCenter.helpCategoryTroubleshooting": "Feilsøking",
  "helpCenter.helpCenter": "Hjelpesenter",
  "helpCenter.landingDescription": "Finn svar på vanlige spørsmål og lær hvordan du får mest mulig ut av SmartMixin.",
  "helpCenter.linkToSection": "Lenke til denne delen",
  "helpCenter.menuItemDescription": "Vanlige spørsmål og veiledninger",
  "helpCenter.minRead": "{minutes} min lesing",
  "helpCenter.onThisPage": "På denne siden",
  "helpCenter.platformMobileApp": "Mobilapp",
  "helpCenter.platformMobileOnly": "Kun i mobilappen",
  "helpCenter.platformWebApp": "Nettapp",
  "helpCenter.platformWebOnly": "Kun i nettappen",
  "helpCenter.popularArticles": "Populære artikler",
  "helpCenter.relatedArticles": "Relaterte artikler",
  "helpCenter.searchArticles": "Søk artikler...",
  "helpCenter.stillNeedHelp": "Trenger du fortsatt hjelp?",
  "helpCenter.stillNeedHelpDescription": "Hvis denne artikkelen ikke besvarte spørsmålet ditt, hjelper jeg deg gjerne direkte.",
  "helpCenter.supportEmailSubject": "SmartMixin-hjelp",
  "helpCenter.supportEmailSubjectTopic": "SmartMixin-hjelp — {topic}",
  "helpCenter.thankYouForFeedback": "Takk for tilbakemeldingen!",
  "helpCenter.wasArticleHelpful": "Var denne artikkelen nyttig?",
  "intro.locationDescription": "Aktiver stedstilgang for å få nøyaktige værvarsler tilpasset ditt eksakte område — ikke flere generelle prognoser.",
  "intro.locationTitle": "Prognoser laget for deg",
  "intro.notificationDescription": "Slå på varsler for å få tidsriktige meldinger om værendringer som betyr noe for deg — regn, snø eller alvorlige forhold, akkurat når du trenger det.",
  "intro.notificationsTitle": "Gå aldri glipp av en værendring",
  "intro.readyDescription": "Nyt presise prognoser, sanntids værinnsikt og stasjonsdata fra hele verden — alt i én kraftig app.",
  "intro.readyTitle": "Du er klar!",
  "intro.welcomeDescription": "Få hyperlokale prognoser fra ledende værbyråer — pluss tilgang til over 40 000 værstasjoner over hele verden for å se reelle forhold, både nåtid og fortid.",
  "intro.welcomeTitle": "Været ditt, gjenoppfunnet",
  "landing.alsoAvailableOn": "Også tilgjengelig på:",
  "landing.featureAlertsDescription": "Angi egne terskelverdier for alle måleverdier. Bli varslet når temperaturen synker, regnet starter eller vinden tiltar.",
  "landing.featureAlertsTitle": "Smarte varsler",
  "landing.featureAnalyticsDescription": "Interaktive diagrammer, trendanalyse og detaljert statistikk. Dykk ned i data om temperatur, luftfuktighet, lufttrykk, regn og vind.",
  "landing.featureAnalyticsTitle": "Avansert analyse",
  "landing.featureExportDescription": "Få alle værdataene dine på e-post som et Excel-regneark, klart for videre analyse i Excel, Google Regneark eller favorittverktøyene dine.",
  "landing.featureExportTitle": "Eksporter dataene dine",
  "landing.featureForecastDescription": "Få tilgang til {count, plural, one {#+ profesjonell prognosemodell} other {#+ profesjonelle prognosemodeller}}, inkludert ECMWF, GFS og regionale modeller. Sammenlign dem side om side og lag dine egne prognoser.",
  "landing.featureForecastTitle": "Sammenlign prognosemodeller",
  "landing.featureHistoryDescription": "Få tilgang til historiske data med time-, dags- og månedsskala. Eksporter dem til Excel for forskning eller personlige arkiver.",
  "landing.featureHistoryTitle": "Rik historikk",
  "landing.featureMultiBrandDescription": "Koble til Netatmo, Davis, Tempest, Ecowitt, Ambient Weather og flere. Slutt på å bytte mellom apper.",
  "landing.featureMultiBrandTitle": "Alle merker, én app",
  "landing.featuresSubtitle": "SmartMixin gir deg verktøyene til å analysere, sammenligne og forstå værdataene dine som en proff.",
  "landing.featuresTitle": "Laget for dataelskere",
  "landing.finalCtaButton": "Opprett gratis konto",
  "landing.finalCtaSubtitle": "Bli med tusenvis av værentusiaster som stoler på SmartMixin.",
  "landing.finalCtaTitle": "Klar til å dykke dypere ned i værdataene dine?",
  "landing.heroCta": "Start gratis",
  "landing.heroDescription": "Grundig analyse, vakre diagrammer og profesjonelle prognoser — alle værstasjonene dine samlet i én kraftig app.",
  "landing.heroSecondaryCta": "Utforsk kartet",
  "landing.heroTagline": "For værentusiaster",
  "landing.heroTitle": "Se været ditt som aldri før",
  "landing.pricingFeatureAdvancedMetrics": "Avanserte målinger",
  "landing.pricingFeatureAlerts": "Tilpassede varsler",
  "landing.pricingFeatureExport": "Dataeksport (Excel)",
  "landing.pricingFeatureForecastComparison": "Prognosesammenligning",
  "landing.pricingFeatureForecasts": "Prognosemodeller",
  "landing.pricingFeatureForecastsFreeTier": "1 modell",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ modell} other {#+ modeller}}",
  "landing.pricingFeatureReports": "Analyser og rapporter",
  "landing.pricingFeatureStationComparison": "Stasjonssammenligning",
  "landing.pricingFeatureWidgets": "Startskjerm-widgeter",
  "landing.pricingFeatureYearOverYear": "År-til-år-analyse",
  "landing.pricingFreeCta": "Kom i gang",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Mest populær",
  "landing.pricingPremiumCta": "Kom i gang",
  "landing.pricingPremiumDescription": "Fra 1,99 €/måned — abonner på nett, App Store eller Google Play",
  "landing.pricingSubtitle": "Start gratis, oppgrader når du trenger mer.",
  "landing.pricingTitle": "Enkel, gjennomsiktig prising",
  "landing.statBrands": "Støttede merker",
  "landing.statForecasts": "Prognosemodeller",
  "landing.statStations": "Værstasjoner",
  "landing.supportedDevicesNote": "Pluss over {count, number} offentlige stasjoner fra Verdens meteorologiorganisasjons nettverk",
  "landing.supportedDevicesSubtitle": "Koble til den eksisterende værstasjonen din på få minutter. Vi støtter {count, plural, one {# stort merke} other {# store merker}}, og flere kommer til.",
  "landing.supportedDevicesTitle": "Fungerer med stasjonen din",
  "metrics.absolutePressure": "Absolutt trykk",
  "metrics.airDensity": "Lufttetthet",
  "metrics.airGap": "Luftspalte",
  "metrics.apparentTemperature": "Tilsynelatende temperatur",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Gj. snitt",
  "metrics.avg_wind": "Gjennomsnittlig vind",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Svartkuletemperatur",
  "metrics.boilerOn": "Kjele På",
  "metrics.boilerOnInHours": "Kjele På (timer)",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Ledningsevne",
  "metrics.dailyPrecipitation": "Daglig nedbør",
  "metrics.dailyRain": "Daglig nedbør",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "Dybde",
  "metrics.depthSensors": "Dybdesensorer",
  "metrics.dewPoint": "Duggpunkt",
  "metrics.distance": "Avstand",
  "metrics.downTrend": "ned",
  "metrics.ET": "Evapotranspirasjon",
  "metrics.etToday": "ET i dag",
  "metrics.feelsLike": "Følt temperatur",
  "metrics.feelsLikeWithFormula": "Følt temperatur ({formula})",
  "metrics.frostPoint": "Frostpunkt",
  "metrics.gust": "Vindkast",
  "metrics.hail": "Hagl",
  "metrics.heatIndex": "Varmeindeks",
  "metrics.heatingDegreeDays": "Oppvarmingsgraddager",
  "metrics.heatingPower": "Varmekraft",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Luftfuktighet",
  "metrics.lastLightningImpact": "Siste nedslag",
  "metrics.lastMeasure": "Siste måling",
  "metrics.leafSensors": "Bladsensorer",
  "metrics.leafWetness": "Bladfuktighet",
  "metrics.lightningDistance": "Avstand",
  "metrics.lightningStrikeCount": "Antall lynnedslag",
  "metrics.lightningStrikeDistance": "Lynavstand",
  "metrics.max": "Maks.",
  "metrics.max_gust": "Maks. vindkast",
  "metrics.maxToday": "Maks. i dag",
  "metrics.min": "Min.",
  "metrics.noise": "Støy",
  "metrics.normalizedHeatingCoefficient": "Normalisert oppvarmingskoeffisient",
  "metrics.outdoorTemperature": "Utetemperatur",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "Nedbør",
  "metrics.pressure": "Lufttrykk",
  "metrics.rain": "Regn",
  "metrics.rainDurationValue": "Regnvarighet: {duration}",
  "metrics.rainfallMeasurement": "Nedbørsmåling",
  "metrics.rainRate": "Regnintensitet",
  "metrics.relativePressure": "Relativt trykk",
  "metrics.setPoint": "Settpunkt",
  "metrics.snow": "Snø",
  "metrics.snowfall": "Snøfall",
  "metrics.soilMoisture": "Fuktighet",
  "metrics.soilSensors": "Jordsensorer",
  "metrics.soilWaterTension": "Jordvannspenning",
  "metrics.solarEnergy": "Solenergi",
  "metrics.solarRadiation": "Solstråling",
  "metrics.speed": "Hastighet",
  "metrics.stableTrend": "stabil",
  "metrics.sum": "Sum",
  "metrics.temperature": "Temperatur",
  "metrics.temperatureSensors": "Temperatur- og fuktighetssensorer",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "opp",
  "metrics.uv": "UV",
  "metrics.visibility": "Sikt",
  "metrics.weatherCondition": "Værforhold",
  "metrics.wetBulbGlobeTemperature": "Våtkuletemperatur (Wet bulb globe)",
  "metrics.wetBulbTemperature": "Våttemperatur (Wet bulb)",
  "metrics.wind": "Vind",
  "metrics.windChill": "Vindavkjøling",
  "metrics.windDirection": "Vindretning",
  "metrics.windMeasurement": "Vindmåling",
  "metrics.windRun": "Vinddistanse",
  "metrics.windRunDescription": "Vinddistanse er den totale avstanden vinden tilbakelegger over en tidsperiode",
  "metrics.windSpeed": "Vindhastighet",
  "network.cancelError": "Forespørselen er kansellert",
  "network.connectionError": "Serveren er ikke tilgjengelig",
  "network.networkError": "Nettverk ikke tilgjengelig",
  "network.serverError": "Noe gikk galt...",
  "network.timeoutError": "Tidsavbrudd for tilkobling",
  "network.unknownError": "Ukjent feil",
  "premium.alreadyPremium": "Du har allerede en premiumkonto!",
  "premium.bestValue": "Mest for pengene",
  "premium.billingDetailsAndroid": "Gratis prøveperiode: Du blir ikke belastet hvis du sier opp minst 24 timer før prøveperioden er over. Deretter fornyes SmartMixin-abonnementet ditt automatisk med mindre du sier det opp minst 24 timer før slutten av gjeldende periode; du kan si opp når som helst i kontoinnstillingene i Google Play. Hver fornyelse belastes med prisen som vises på knappen ovenfor. Betalingen belastes Google Play-kontoen din når du bekrefter kjøpet, og ved starten av hver fornyelsesperiode.",
  "premium.billingDetailsIos": "Gratis prøveperiode: Du blir ikke belastet hvis du sier opp minst 24 timer før prøveperioden er over. Deretter fornyes SmartMixin-abonnementet ditt automatisk med mindre du sier det opp minst 24 timer før slutten av gjeldende periode; du kan si opp når som helst i kontoinnstillingene i App Store. Hver fornyelse belastes med prisen som vises på knappen ovenfor. Betalingen belastes App Store-kontoen din når du bekrefter kjøpet, og ved starten av hver fornyelsesperiode.",
  "premium.freeBannerBody": "Gratiskontoer får GFS overalt — de foretrukne modellene dine og «overalt ellers» begynner å virke i det øyeblikket du abonnerer.",
  "premium.freeBannerTitle": "Innstillingene gjelder med Premium",
  "premium.freeSubscription": "Gratis Premium-abonnement",
  "premium.freeTrialForPeriod": "Gratis prøveperiode i {period, plural, one {# dag} other {# dager}}",
  "premium.getUnlimitedAccess": "Ubegrenset tilgang til:",
  "premium.manageMySubscription": "Administrer abonnementet mitt",
  "premium.notPurchasedYet": "Fant ikke noe kjøp av SmartMixin Premium for denne butikkontoen.",
  "premium.orChooseMonthly": "Eller velg månedlig:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Aktiv",
  "premium.premiumAnnualTrialInfo": "Start med en gratis prøveperiode på {days, plural, one {# dag} other {# dager}}",
  "premium.premiumCurrentPlan": "Nåværende abonnement",
  "premium.premiumDownloadApp": "Last ned appen for å abonnere:",
  "premium.premiumEndsOn": "Utløper {date}",
  "premium.premiumFeatureAlerts": "Værvarslinger",
  "premium.premiumFeatureAnalysis": "Avansert væranalyse",
  "premium.premiumFeatureCharts": "Diagramsammenligninger",
  "premium.premiumFeatureExport": "Dataeksport",
  "premium.premiumFeatureForecast": "Regionale prognosemodeller",
  "premium.premiumFeatureNotification": "Statuslinje-widget",
  "premium.premiumFeatureTitle": "Premium-funksjon",
  "premium.premiumFeatureWidgets": "Startskjerm-widgeter",
  "premium.premiumFreePlan": "Gratis",
  "premium.premiumInactive": "Ikke abonnert",
  "premium.premiumManageStoreSubscription": "Du abonnerer via {store}. Administrer eller si opp abonnementet der.",
  "premium.premiumManageWebSubscription": "Administrer abonnementet ditt, oppdater betalingsmetode eller avbryt.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Fornyes {date}",
  "premium.premiumSubscribeAnnual": "Årlig — 9,99 €/år",
  "premium.premiumSubscribedOn": "Abonnert på {platform}",
  "premium.premiumSubscribedOnWeb": "Abonnert på nettet",
  "premium.premiumSubscribeMonthly": "Månedlig — 1,99 €/måned",
  "premium.premiumSubscribeOnWeb": "Abonner nå for å låse opp alle premium-funksjoner.",
  "premium.premiumSubscriptionSuccess": "Abonnementet ditt er aktivert! Nyt alle premium-funksjoner.",
  "premium.premiumSubscriptionSuccessTitle": "Velkommen til Premium!",
  "premium.premiumWebappNotice": "Det er ikke mulig å abonnere på nettet akkurat nå.",
  "premium.pricePerMonth": "{price}/måned",
  "premium.pricePerYear": "{price}/år",
  "premium.purchasedNetatmoPro": "Du har tidligere kjøpt Netatmo Pro ({date}). Det gir deg tilgang til en del av Premium-funksjonene. Abonner på ett av følgende tilbud hvis du vil ha tilgang til alle Premium-funksjoner.",
  "premium.purchaseFailed": "Kjøpet kunne ikke fullføres. Prøv igjen.",
  "premium.restoreFailed": "Kjøpene dine kunne ikke gjenopprettes. Prøv igjen.",
  "premium.restorePurchase": "Gjenopprett kjøp",
  "premium.savingsPercent": "Spar {percent}%",
  "premium.seePremium": "Se Premium",
  "premium.startFreeTrial": "Start gratis prøveperiode",
  "premium.storeUnavailable": "Butikken er ikke tilgjengelig akkurat nå. Prøv igjen senere.",
  "premium.subscribeNow": "Abonner nå — uten prøveperiode",
  "premium.switchToPremium": "Bytt til SmartMixin Premium",
  "premium.thenPrice": "deretter {price}",
  "providerHints.ambientWeatherApiKey": "Opprettet i kontoinnstillingene på ambientweather.net.",
  "providerHints.davisApiSecret": "Vises bare én gang når du opprettet V2 API-nøkkelen — oppbevar trygt.",
  "providerHints.davisV2ApiKey": "Fra V2 API-nøkkelsiden på weatherlink.com.",
  "providerHints.ecowittApi": "Fra API-siden på Ecowitt-kontoen din.",
  "providerHints.ecowittApp": "Applikasjonsnøkkelen, også fra Ecowitt-kontoen din.",
  "providerHints.myAcuriteCredentialsBanner": "Bruk e-post og passord til My AcuRite-kontoen din — ikke SmartMixin-innloggingen.",
  "providerHints.myAcuriteEmail": "E-postadressen til My AcuRite-kontoen din — ikke SmartMixin-innloggingen.",
  "providerHints.myAcuritePassword": "Passordet til My AcuRite-kontoen din.",
  "providerHints.weatherflowToken": "Personlig token fra tempestwx.com → innstillinger → dataautorisasjoner.",
  "providerHints.wundergroundEditKey": "Bruk en annen nøkkel",
  "providerHints.wundergroundKey": "En lang streng fra API-nøkkelsiden på Weather Underground-kontoen din — ikke wunderground.com-passordet ditt.",
  "providerHints.wundergroundKeyExample": "f.eks. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-nøkkel bekreftet",
  "providerHints.wundergroundNoStationsNearby": "Ingen stasjoner funnet i nærheten. Prøv å skrive inn en stasjons-ID direkte.",
  "providerHints.wundergroundStationIdExample": "f.eks. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Hent Ambient Weather API-nøkkelen din.",
  "providerIntro.davisStep2": "Hent Davis V2 API-nøkkelen og API-hemmeligheten din.",
  "providerIntro.ecowittStep2": "Hent Ecowitt API-nøkkelen og applikasjonsnøkkelen din.",
  "providerIntro.getStarted": "Kom i gang",
  "providerIntro.myAcuriteStep2": "Bruk e-post og passord til din eksisterende My AcuRite-konto.",
  "providerIntro.netatmoEnergyStep2": "Logg inn på Netatmo når du blir bedt om det — ingen API-nøkkel nødvendig.",
  "providerIntro.netatmoWeatherStep2": "Logg inn på Netatmo når du blir bedt om det — ingen API-nøkkel nødvendig.",
  "providerIntro.signupBanner": "Nesten ferdig — opprett en gratis SmartMixin-konto for å koble til {provider}.",
  "providerIntro.step1": "Logg inn på SmartMixin-kontoen din (IKKE {provider}-innloggingen).",
  "providerIntro.step3EmailPassword": "Skriv inn her.",
  "providerIntro.step3KeyOrToken": "Lim inn her.",
  "providerIntro.step3OAuth": "Godkjenn SmartMixin i popup-vinduet.",
  "providerIntro.step3Wunderground": "Lim inn API-nøkkelen din, og velg deretter en stasjon i nærheten eller skriv inn en hvilken som helst stasjons-ID.",
  "providerIntro.title": "Koble til {provider}",
  "providerIntro.weatherflowStep2": "Hent ditt personlige Tempest-token.",
  "providerIntro.wundergroundBrowsePublic": "Har du ingen stasjon? Bla gjennom offentlige",
  "providerIntro.wundergroundFindNearby": "Finn stasjoner i nærheten",
  "providerIntro.wundergroundOrEnterId": "Eller skriv inn en stasjons-ID",
  "providerIntro.wundergroundStep2": "Hent Weather Underground API-nøkkelen din. Deretter kan du koble til en hvilken som helst stasjon — din egen eller en offentlig.",
  "reports.agroMeteorology": "Agrometeorologi",
  "reports.analysis": "Analyse",
  "reports.annualCumulativeRainfallComparison": "Årlig nedbørssammenligning",
  "reports.annualHeatingDurationComparison": "Sammenligning av årlig oppvarmingsvarighet",
  "reports.annualHeatingEfficiency": "Årlig oppvarmingseffektivitet",
  "reports.annualIndoorComparison": "Årlig innendørs sammenligning",
  "reports.annualOutdoorComparison": "Årlig utendørs sammenligning",
  "reports.annualOutdoorReport": "Årlig utendørsrapport",
  "reports.annualReport": "Årlig rapport",
  "reports.annualSolarReport": "Årlig solrapport",
  "reports.annualWaterBalance": "Årlig vannbalanse",
  "reports.annualWaterBalanceCarryOver": "Overfør {year} ({value})",
  "reports.annualWaterBalanceDescription": "Vannbalansen (forenklet versjon, kun regn og evapotranspirasjon brukes) hjelper til med å styre vannforsyningen",
  "reports.avgHumidity": "Gjennomsnittlig luftfuktighet",
  "reports.avgMaxTemperature": "Gjennomsnittlig T°maks",
  "reports.avgMetric": "Gjennomsnitt – {metric}",
  "reports.avgMinTemperature": "Gjennomsnittlig T°min",
  "reports.avgPressure": "Gjennomsnittlig lufttrykk",
  "reports.avgTemperature": "Gjennomsnittstemperatur",
  "reports.chartsAndTable": "Diagrammer og tabell",
  "reports.climateNormalPeriodOfRecord": "Måleperiode ({years} år)",
  "reports.climateNormals": "Klimanormaler",
  "reports.climateNormalStandardLabel": "Standardnormal ({period})",
  "reports.climateTrendPerDecade": "Temperaturtrend: {value} per tiår over {years} år",
  "reports.coldestMonthRanking": "Kaldeste {month} som er målt",
  "reports.comfortable": "Komfortabelt (45% {lessThan} Fuktighet ≤ 60%)",
  "reports.cumulativeRainfall": "Kumulativ nedbør",
  "reports.cumulativeRainfallDescription": "Følg den totale nedbøren som akkumuleres over den valgte perioden.",
  "reports.dailyMaxRainfall": "Daglig maks. nedbør",
  "reports.dataExport": "Eksporter data",
  "reports.dataExportXlsxFormatDescription": "Eksporter alle stasjonens værdata i Excel format (*.xlsx). Når du klikker på knappen vil du om noen minutter motta en E-post med de behandlede dataene.",
  "reports.daysOfData": "{days, plural, one {# dag med data} other {# dager med data}}",
  "reports.daysWithFrost": "Dager med frost",
  "reports.daysWithHeavyRain": "Dager med kraftig regn (≥ {threshold})",
  "reports.daysWithoutThaw": "Dager uten smelting",
  "reports.daysWithStrongFrost": "Dager med sterk frost",
  "reports.emailSent": "En E-post er sendt til postkassen din",
  "reports.frostDays": "Frostdager",
  "reports.grasslandTemperatureSum": "Sum temperatur på gress",
  "reports.grasslandTemperatureSumDescription": "Når summen {threshold} overskrides om våren er den bærekraftige starten på vegetasjon/landbruk oppnådd (fungerer for Europa)",
  "reports.growingDegreeDays": "Vekstgraddager",
  "reports.highPressure": "Antisyklon (gjennomsnittlig trykk ≥ 1013mbar)",
  "reports.iceDays": "Isdager",
  "reports.indoorReport": "Innendørsrapport",
  "reports.keyFacts": "Nøkkelfakta",
  "reports.longestDrySpell": "Lengste tørre periode",
  "reports.longestRunOfRainyDays": "Lengste periode med regnværsdager",
  "reports.longestRunWithoutRun": "Lengste periode uten regn",
  "reports.longestWetSpell": "Lengste våte periode",
  "reports.lowPressure": "Lavt lufttrykk (gjennomsnittlig trykk {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maksimal luftfuktighet",
  "reports.maxMetric": "Maksimum – {metric}",
  "reports.maxPressure": "Maksimalt lufttrykk",
  "reports.maxTemperature": "Maksimal temperatur",
  "reports.maxTempGreaterThan": "T°maks ≥",
  "reports.maxTempMagnitude24h": "Maksimal forskjell (/24t)",
  "reports.minHumidity": "Minimum luftfuktighet",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Minimum lufttrykk",
  "reports.minTemperature": "Minimumstemperatur",
  "reports.minTempMagnitude24h": "Minste forskjell (/24t)",
  "reports.monthlyAverageCountdown": "{days, plural, one {# dag til} other {# dager til}} denne måneden",
  "reports.monthlyAverageCountdownDetail": "Da vises månedens gjennomsnitt og plassering.",
  "reports.monthlyAverageRule": "Månedlige gjennomsnitt og plasseringer vises når en kalendermåned har {days, plural, one {# registrert dag} other {# registrerte dager}}.",
  "reports.monthlyHeatingEfficiency": "Månedlig oppvarmingseffektivitet",
  "reports.monthlyOutdoorReport": "Månedlig utendørsrapport",
  "reports.monthlyReport": "Månedlig rapport",
  "reports.monthlySolarReport": "Månedlig solrapport",
  "reports.monthlyWindReport": "Månedlig vindrapport",
  "reports.monthsOfData": "{months} måneder med data",
  "reports.numberOfDays": "Antall dager",
  "reports.outdoorReport": "Utendørsrapport",
  "reports.overviewSection": "Oversikt",
  "reports.rainfall": "Nedbør",
  "reports.rainyDays": "Dager med regn",
  "reports.recordDailyRain": "Våteste dag",
  "reports.recordHigh": "Varmerekord",
  "reports.recordLow": "Kulderekord",
  "reports.recordsAndClimatology": "Rekorder og klima",
  "reports.recordsSince": "Rekorder siden {date}",
  "reports.recordWindGust": "Sterkeste vindkast",
  "reports.relativelyWet": "Relativt vått (60% {lessThan} Fuktighet ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# rapport} other {# rapporter}}",
  "reports.sendEmail": "Send E-post",
  "reports.summerDays": "Sommerdager",
  "reports.tooDry": "For tørt (Fuktighet ≤ 45%)",
  "reports.tooWet": "For vått (Fuktighet {greaterThan} 80%)",
  "reports.tropicalNights": "Tropiske netter",
  "reports.unlockPremiumSubtitle": "Inkludert i SmartMixin Premium",
  "reports.unlockPremiumTitle": "Lås opp {count, plural, one {# premiumfunksjon} other {# premiumfunksjoner}}",
  "reports.warmestMonthRanking": "Varmeste {month} som er målt",
  "reports.waterBalance": "Vannbalanse",
  "reports.yearsOfData": "{years} år med data",
  "reports.yearToDateTemperatureComparison": "Sammenligning av temperatur hittil i år",
  "sensors.bgtSensors": "Svartkule & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareHumidity": "Sammenlign fuktighet",
  "sensors.compareMoisture": "Sammenlign jordfuktighet",
  "sensors.comparePm25": "Sammenlign PM2.5",
  "sensors.compareTemperatures": "Sammenlign temperaturer",
  "sensors.compareWaterTension": "Sammenlign jordvannspenning",
  "sensors.depthByChannel": "Dybde per kanal",
  "sensors.heatStressExtreme": "Ekstrem varmestress",
  "sensors.heatStressModerate": "Moderat varmestress",
  "sensors.heatStressNone": "Ingen varmestress",
  "sensors.heatStressStrong": "Sterk varmestress",
  "sensors.heatStressVeryStrong": "Svært sterk varmestress",
  "sensors.indoorClimate": "Inneklima",
  "sensors.indoorCo2Levels": "CO2-nivåer",
  "sensors.indoorTemperatureAndHumidity": "Temperatur og fuktighet",
  "sensors.leafWetnessByChannel": "Bladfuktighet per kanal",
  "sensors.lightningSensor": "Lyn",
  "sensors.moistureByChannel": "Jordfuktighet per kanal",
  "sensors.noDataAvailable": "Ingen data tilgjengelig",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 per kanal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Velg kanal",
  "sensors.sensorDetailDescription": "Se historiske data og trender for sensorkanalene dine.",
  "sensors.sensorHistory": "Sensorhistorikk",
  "sensors.soilConductivityByChannel": "Ledningsevne per kanal",
  "sensors.soilTemperatureByChannel": "Jordtemperatur per kanal",
  "sensors.strikesToday": "Nedslag i dag",
  "sensors.temperatureByChannel": "Temperatur per kanal",
  "sensors.viewChart": "Vis graf",
  "sensors.waterTensionByChannel": "Jordvannspenning per kanal",
  "settings.appearance": "Utseende",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabisk",
  "settings.bulgarian": "bulgarsk",
  "settings.catalan": "katalansk",
  "settings.chartGestures": "Bevegelser på diagrammer",
  "settings.chartGesturesDescription": "Sveiping på diagrammer endrer tidsperioden, kniping på diagrammer endrer tidsskala",
  "settings.choiceCount": "{count, plural, one {# tilgjengelig} other {# tilgjengelige}}",
  "settings.contactUs": "Kontakt oss",
  "settings.contactUsDescription": "Få hjelp eller send tilbakemelding",
  "settings.croatian": "kroatisk",
  "settings.czech": "tsjekkisk",
  "settings.dailyDetailByPeriods": "Dagsdetaljer etter perioder",
  "settings.dailyDetailByPeriodsDescription": "Grupper de 24 timene i natt, morgen, ettermiddag og kveld — samme inndeling som dagssammendraget bruker.",
  "settings.danish": "dansk",
  "settings.dark": "Mørkt tema",
  "settings.dataDisplay": "Datavisning",
  "settings.dateAndTime": "Dato og tid",
  "settings.donateButton": "Gi en donasjon",
  "settings.donateDescription": "SmartMixin er laget av et lite team. Hvis du har nytte av den, kan du støtte utviklingen med en engangsdonasjon på et hvilket som helst beløp. Det er en gave — den endrer ikke abonnementet ditt og låser ikke opp noen funksjoner.",
  "settings.donateSuccessBody": "Donasjonen din bidrar til å holde SmartMixin i gang og gjøre den bedre. Vi setter stor pris på det.",
  "settings.donateSuccessTitle": "Takk for støtten!",
  "settings.donateTitle": "Støtt SmartMixin",
  "settings.dragToReorder": "Dra for å endre rekkefølge",
  "settings.dutch": "nederlandsk",
  "settings.english": "engelsk",
  "settings.french": "fransk",
  "settings.german": "tysk",
  "settings.gestures": "Bevegelser",
  "settings.greek": "gresk",
  "settings.hungarian": "ungarsk",
  "settings.italian": "italiensk",
  "settings.japanese": "japansk",
  "settings.korean": "koreansk",
  "settings.language": "Språk",
  "settings.languageDescription": "Foretrukket språk",
  "settings.light": "Lyst tema",
  "settings.measurementUnits": "Måleenheter",
  "settings.netatmoDashboard": "Netatmo-oversikt",
  "settings.netatmoLayoutCards": "Kortliste",
  "settings.netatmoLayoutCardsDescription": "Ett kort per modul, alt i én rulling",
  "settings.netatmoLayoutClassic": "Klassisk",
  "settings.netatmoLayoutClassicDescription": "To kort, bytt mellom moduler",
  "settings.netatmoNewLayoutNotice": "Nytt oppsett: ett kort per modul.",
  "settings.netatmoSwitchBackToClassic": "Tilbake til klassisk",
  "settings.netatmoSwitchToLayout": "Bytt til {layout}",
  "settings.norwegian": "norsk",
  "settings.notificationsSection": "Varsler",
  "settings.ongoingNotificationEnabled": "Aktiver permanent varsel",
  "settings.ongoingNotificationMetrics": "Viste målinger",
  "settings.ongoingNotificationPermissionRequired": "Varslingstillatelse kreves",
  "settings.ongoingNotificationPreviewHint": "Forhåndsvisning — slå på widgeten for å vise den",
  "settings.ongoingNotificationStatusBar": "Statuslinje",
  "settings.polish": "polsk",
  "settings.portuguese": "portugisisk",
  "settings.preferencesSection": "Preferanser",
  "settings.privacyPolicy": "Personvernerklæring",
  "settings.russian": "russisk",
  "settings.serbian": "serbisk",
  "settings.settings": "Innstillinger",
  "settings.settingsPageTitle": "Innstillinger - {page}",
  "settings.slovak": "slovakisk",
  "settings.smallDecimals": "Små desimaler",
  "settings.smallDecimalsDescription": "Vis desimaltall i en mindre størrelse",
  "settings.spanish": "spansk",
  "settings.statusBarWidget": "Statuslinje-widget",
  "settings.statusBarWidgetDescription": "Alltid synlige værdata",
  "settings.subscriptionSection": "Abonnement",
  "settings.supportSection": "Støtte",
  "settings.swedish": "svensk",
  "settings.systemTheme": "Systemtema",
  "settings.termsOfService": "Vilkår for bruk",
  "settings.turkish": "tyrkisk",
  "settings.ukrainian": "ukrainsk",
  "settings.units": "Enheter",
  "settings.unitsDescription": "Måleenheter som benyttes i appen",
  "settings.update": "Oppdater",
  "settings.windDirectionConvention": "Vindretningspil",
  "settings.windDirectionConventionDescription": "Velg hvordan vindretningspiler vises",
  "settings.windDirectionMeteorological": "Opprinnelsesretning",
  "settings.windDirectionMeteorologicalDescription": "Pilen viser hvor vinden kommer fra (meteorologisk konvensjon)",
  "settings.windDirectionOceanographic": "Strømningsretning",
  "settings.windDirectionOceanographicDescription": "Pilen viser hvor vinden blåser (oseanografisk konvensjon)",
  "stations.addAStation": "Legg til en stasjon",
  "stations.addToFavorites": "Legg til i favoritter",
  "stations.addYourOwnStation": "Legg til din egen stasjon",
  "stations.clearRecentLocations": "Fjern alle",
  "stations.clearSearch": "Tøm søk",
  "stations.currentLocation": "Nåværende plassering",
  "stations.customizedStationName": "Tilpasset stasjonsnavn",
  "stations.favoriteLocations": "Favoritter",
  "stations.favoriteLocationsEmpty": "Du kan legge til opptil 5 favorittsteder.",
  "stations.favoriteStations": "Favorittstasjoner",
  "stations.filterStationDescription": "Ikke vis stasjoner med upålitelige målinger",
  "stations.filterStations": "Filtrer stasjoner",
  "stations.filterStationSourceDescription": "Velg stasjonsleverandører som du vil vise på kartet",
  "stations.findStationsNearYou": "Finn stasjoner i nærheten",
  "stations.hiddenStations": "Skjulte stasjoner",
  "stations.hiddenStationsDescription": "Du kan vise en skjult stasjon igjen ved å tappe øyeikonet ved siden av.",
  "stations.lastSeen": "sist sett {time}",
  "stations.location": "Plassering",
  "stations.locationAddedToFavorites": "Plassering lagt til favoritter",
  "stations.locationNotGranted": "Plasseringstillatelse er ikke gitt. Gi tilgang til ditt sted i enhetsinnstillinger.",
  "stations.locationRemovedFromFavorites": "Plassering fjernet fra favoritter",
  "stations.locations": "Steder",
  "stations.locationUnavailable": "Kunne ikke hente posisjonen din. Sjekk innstillingene på enheten.",
  "stations.maxFavoriteLocationsReached": "Du kan bare ha opptil 5 favorittsteder. Fjern en for å legge til en annen.",
  "stations.modifyFavoriteStations": "Endre favorittstasjoner",
  "stations.modifyFavoriteStationsDescription": "Du kan omorganisere favorittstasjonene dine ved å dra dem. Du kan også fjerne dem fra listen.",
  "stations.myLocation": "Min posisjon",
  "stations.nearbyWeatherStations": "Værstasjoner i nærheten",
  "stations.noLocationsFound": "Ingen steder funnet",
  "stations.noSearchResults": "Ingen artikler samsvarer med søket ditt",
  "stations.noStationsFound": "Ingen stasjoner funnet",
  "stations.noWeatherStationYet": "Du har ikke en værstasjon ennå.",
  "stations.recentLocations": "Nylige",
  "stations.recentLocationsEmpty": "Historikken din er tom.",
  "stations.removeFromFavorites": "Fjern fra favoritter",
  "stations.searchForLocation": "Søk etter et sted",
  "stations.searchForWeatherStation": "Søk etter en værstasjon",
  "stations.searchResults": "Søkeresultater",
  "stations.searchResultsEmpty": "Ingen resultater funnet.",
  "stations.searchResultsFound": "{count, plural, one {# resultat funnet} other {# resultater funnet}}",
  "stations.searchStationsDescription": "Skriv inn en by, adresse eller stedsnavn for å finne værstasjoner i nærheten.",
  "stations.searchStationsHint": "Bruk søkefeltet ovenfor for å oppdage værstasjoner hvor som helst i verden.",
  "stations.selectStationForComparison": "Velg en stasjon å sammenligne med",
  "stations.stationAddedToFavorites": "Stasjon lagt til favoritter",
  "stations.stationCount": "{count, plural, one {# stasjon} other {# stasjoner}}",
  "stations.stationInformation": "Stasjonsinformasjon",
  "stations.stationName": "Stasjonens navn",
  "stations.stationObservationsDescription": "Vis de siste observasjonene fra værstasjoner",
  "stations.stationRemovedFromFavorites": "Stasjonen fjernet fra favoritter",
  "stations.stationsNear": "Stasjoner nær {place}",
  "stations.stationType": "Stasjonstype",
  "stations.statusOffline": "Frakoblet",
  "stations.statusOnline": "Tilkoblet",
  "stations.statusStale": "Utdatert",
  "stations.tryAnotherLocation": "Vi fant ingen værstasjoner i nærheten av dette stedet. Prøv å søke i et annet område.",
  "stations.weatherStation": "Værstasjon",
  "stations.weatherStationCount": "{count, plural, one {# værstasjon} other {# værstasjoner}}",
  "stations.weatherStations": "Værstasjoner",
  "stations.welcomeConnectService": "Eier du en værstasjon? Koble til tjenesten din",
  "stations.welcomeSubtitle": "Ditt vær, alt på ett sted",
  "thermostat.away": "Borte",
  "thermostat.boilerOn": "Kjele På",
  "thermostat.hg": "Frostvakt",
  "thermostat.homeInformation": "Hjeminformasjon",
  "thermostat.homeName": "Hjemmets navn",
  "thermostat.manualBoost": "Manuell boost",
  "thermostat.manualSetpointUntil": "Manuelt settpunkt inntil",
  "thermostat.noThermostatYet": "Du har ikke termostat ennå.",
  "thermostat.relay": "Relé",
  "thermostat.room": "Rom",
  "thermostat.rooms": "Rom",
  "thermostat.smartThermostat": "Smart termostat",
  "thermostat.smartValve": "Smart ventil",
  "thermostat.whenBackHome": "Når kommer du hjem?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Tommer",
  "units.inchOfMercury": "Tommer kvikksølv",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilometer i timen",
  "units.knot": "Knop",
  "units.meterPerSecond": "Meter per sekund",
  "units.milePerHour": "Mile per time",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimeter",
  "units.millimeterOfMercury": "Millimeter kvikksølv",
  "weatherConditions.blizzard": "Snøstorm",
  "weatherConditions.blowingDust": "Fykende støv",
  "weatherConditions.blowingSnow": "Snøfokk",
  "weatherConditions.breezy": "Lett bris",
  "weatherConditions.clear": "Klart",
  "weatherConditions.cloudy": "Overskyet",
  "weatherConditions.drizzle": "Yr",
  "weatherConditions.flurries": "Lett snøfall",
  "weatherConditions.foggy": "Tåke",
  "weatherConditions.freezingDrizzle": "Underkjølt yr",
  "weatherConditions.freezingRain": "Underkjølt regn",
  "weatherConditions.frigid": "Bitende kulde",
  "weatherConditions.hail": "Hagl",
  "weatherConditions.haze": "Dis",
  "weatherConditions.heavyRain": "Kraftig regn",
  "weatherConditions.heavySnow": "Kraftig snøfall",
  "weatherConditions.hot": "Varmt",
  "weatherConditions.hurricane": "Orkan",
  "weatherConditions.isolatedThunderstorms": "Enkelte tordenbyger",
  "weatherConditions.mixedRainAndHail": "Regn og hagl",
  "weatherConditions.mostlyClear": "Stort sett klart",
  "weatherConditions.mostlyCloudy": "Stort sett skyet",
  "weatherConditions.mostlySunny": "Stort sett solrikt",
  "weatherConditions.notAvailable": "Værforhold ikke tilgjengelig",
  "weatherConditions.partlyCloudy": "Delvis skyet",
  "weatherConditions.rain": "Regn",
  "weatherConditions.rainSleet": "Regn og iskorn",
  "weatherConditions.rainSnow": "Regn og snø",
  "weatherConditions.scatteredShowers": "Spredte byger",
  "weatherConditions.scatteredSnowShowers": "Spredte snøbyger",
  "weatherConditions.scatteredThunderstorms": "Spredte tordenbyger",
  "weatherConditions.showers": "Byger",
  "weatherConditions.sleet": "Iskorn",
  "weatherConditions.smoke": "Røyk",
  "weatherConditions.snow": "Snø",
  "weatherConditions.snowShowers": "Snøbyger",
  "weatherConditions.strongStorms": "Kraftige tordenbyger",
  "weatherConditions.sunny": "Solrikt",
  "weatherConditions.thunderstorms": "Tordenbyger",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Tropisk storm",
  "weatherConditions.windy": "Vindfullt",
  "weatherConditions.wintryMix": "Blandet vinternedbør",
  "weatherMap.legendHeavy": "Kraftig",
  "weatherMap.legendLight": "Lett",
  "weatherMap.legendLightningHelp": "Fargen viser alderen på hvert lynnedslag de siste {minutes} minuttene — nyeste i hvitt, eldste i mørkerødt.",
  "weatherMap.legendNewest": "Nyeste",
  "weatherMap.legendOldest": "Eldste",
  "weatherMap.legendStationsHelp": "Markørfargen gjenspeiler verdien av den valgte målingen.",
  "weatherMap.lightningDataAttribution": "Lyndata: Blitzortung.org",
  "weatherMap.lightningStrikes": "Lynnedslag",
  "weatherMap.lightningStrikesDescription": "Vis lynnedslag i sanntid på kartet",
  "weatherMap.mapLayers": "Kartlag",
  "weatherMap.mapLegend": "Karttegnforklaring",
  "weatherMap.radarDataAttribution": "Radardata: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.rainRadar": "Regnradar",
  "weatherMap.rainRadarDescription": "Vis regnradaroverlegg på kartet",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain er en ekstra datakilde levert via Tempest Weather System, drevet av Nearcast Technology. NC Rain-data er et estimat av gjennomsnittlig nedbørakkumulering rundt Tempest på nabolagsnivå",
  "weatherMap.weatherMap": "Værkart",
  "weatherMap.weatherMapMetaDescription": "SmartMixin tilbyr interaktive vær- og radarkart for værforhold over hele verden.",
  "weatherWarnings.activeNow": "Aktive nå",
  "weatherWarnings.fromTime": "Fra {time}",
  "weatherWarnings.hazardAirQuality": "Luftkvalitet",
  "weatherWarnings.hazardAvalanche": "Snøskred",
  "weatherWarnings.hazardCoastalEvent": "Kystfarer",
  "weatherWarnings.hazardFlood": "Flom",
  "weatherWarnings.hazardFog": "Tåke",
  "weatherWarnings.hazardForestFire": "Skogbrann",
  "weatherWarnings.hazardHighTemperature": "Høye temperaturer",
  "weatherWarnings.hazardLowTemperature": "Lave temperaturer",
  "weatherWarnings.hazardOther": "Annen fare",
  "weatherWarnings.hazardRain": "Regn",
  "weatherWarnings.hazardSnowIce": "Snø og is",
  "weatherWarnings.hazardThunderstorm": "Tordenbyger",
  "weatherWarnings.hazardUv": "UV-stråling",
  "weatherWarnings.hazardWind": "Vind",
  "weatherWarnings.lastUpdate": "Sist oppdatert: {time}",
  "weatherWarnings.severityExtreme": "Ekstrem",
  "weatherWarnings.severityFrom": "{severity} fra {time}",
  "weatherWarnings.severityMinor": "Liten",
  "weatherWarnings.severityModerate": "Moderat",
  "weatherWarnings.severityNow": "{severity} nå",
  "weatherWarnings.severitySevere": "Alvorlig",
  "weatherWarnings.severityUntil": "{severity} til {time}",
  "weatherWarnings.source": "Kilde: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, deretter {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# offisielt farevarsel} other {# offisielle farevarsler}}. {hazards}",
  "weatherWarnings.upcoming": "Kommende"
}
